(function() {
  /* start-dbtfy-addons */

  /* start-dbtfy-addtocart-animation */
  function themeAddtocartAnimation() {function AddtocartAnimation() {
      const animationType = theme.settings.dbtfyATCAnimationType;
      const animationInterval = theme.settings.dbtfyATCAnimationInterval * 1000;
      const animationTime = theme.variables.animationSlow;
      const animationClass = `slow ${animationType}`;

      $(".product-single__add-to-cart .btn--add-to-cart:not([disabled])").addClass("btn--addtocart_animation");

      function cartAnim() {
        const btnAnimated = $(".btn--addtocart_animation");

        btnAnimated.addClass(animationClass);

        setTimeout(function() {
          btnAnimated.removeClass(animationClass);
        }, animationTime);
      }

      setInterval(cartAnim, animationInterval);
    }

    AddtocartAnimation();}
  /* end-dbtfy-addtocart-animation */

  /* start-dbtfy-age-check */
  function themeAgeCheck() {}

  function themeAgeCheckDestroy() {}
  /* end-dbtfy-age-check */

  /* start-dbtfy-agree-to-terms */
  function themeAgreeToTerms() {}

  function themeAgreeToTermsDestroy() {}
  /* end-dbtfy-agree-to-terms */

  /* start-dbtfy-automatic-geolocation */
  function themeAutomaticGeolocation() {}
  /* end-dbtfy-automatic-geolocation */

  /* start-dbtfy-back-in-stock */
  function themeBackInStock() {function BackInStock() {
      const dbtfy = document.querySelector(".dbtfy-back_in_stock");

      if (!dbtfy) {
        return;
      }

      const notifyForm = dbtfy.querySelector("form");
      const productOptions = document.querySelectorAll(".product-single__variants");
      const productJson = [];
      let isToShowSuccessForm = false;

      productOptions.length && productOptions.forEach((productOption) => {
        const section = productOption.closest("div[data-section-type='product-template']");
        const sectionId = section.getAttribute("data-section-id");
        const productId = +section.querySelector(".product-single").dataset.productId;
        const productMeta = section.querySelector(".product-single__meta--wrapper");

        setUnavailableVariantOnFormSuccess(section, productId);

        if ($(`#ProductJson-${sectionId}`).length) {
          productJson[sectionId] = JSON.parse(document.getElementById(`ProductJson-${sectionId}`).innerHTML);

          if (productMeta) {
            const config = {
              attributes: true,
              childList: false,
              subtree: false
            };

            const observer = new MutationObserver(() => {
              setFormVisibility(section, productJson);
            });

            observer.observe(productMeta, config);
          }

          document.body.addEventListener("change", function (e) {
            setFormVisibility(section, productJson, true);
          });

          setFormVisibility(section, productJson, true);
        }
      });

      sessionStorage.removeItem("notify_products");

      updateColorSwatchesLabels();

      notifyForm && notifyForm.addEventListener("submit", () => {
        const productSection = notifyForm.closest("div[data-section-type='product-template']");
        const productId = +productSection.querySelector(".product-single").dataset.productId;
        const variantSelect = productSection.querySelector("[id^='MainProductSelect']");
        const currentVariant = variantSelect.querySelector("option:checked");
        const variantId = currentVariant ? +currentVariant.value : null;
        const savedNotifyProducts = sessionStorage.getItem("notify_products");
        let notifyProducts = [];

        if (savedNotifyProducts) {
          notifyProducts = JSON.parse(savedNotifyProducts);
        }

        notifyProducts = notifyProducts.filter((product) => {
          return product.id !== productId;
        });

        notifyProducts.push({
          id: productId,
          variantId: variantId
        });

        sessionStorage.setItem("notify_products", JSON.stringify(notifyProducts));
      });

      function updateColorSwatchesLabels() {
        const colorSwatches = document.querySelectorAll(".input-color_swatches:checked");

        colorSwatches.forEach((colorSwatch) => {
          const swatchElementsWrapper = colorSwatch.closest(".custom_swatch_elements");
          const colorOptionLabel = swatchElementsWrapper ? swatchElementsWrapper.querySelector(".label-color_swatches") : null;
          const colorOptionLabelValue = colorOptionLabel ? colorOptionLabel.getAttribute("data-label") : null;
          const optionValue = colorSwatch.value;

          if (colorOptionLabel && colorOptionLabelValue) {
            colorOptionLabel.innerHTML = `${colorOptionLabelValue}: <span class="variant-label-option-value">${optionValue}</span>`;
          }
        });
      }

      function setUnavailableVariantOnFormSuccess(section, productId) {
        const savedNotifyProducts = sessionStorage.getItem("notify_products");
        const notifyProducts = savedNotifyProducts ? JSON.parse(savedNotifyProducts) : [];
        const notifyProduct = notifyProducts.find((notifyProduct) => {
          return notifyProduct.id === productId;
        });

        if (!notifyProduct) {
          return;
        }

        const productSelectorType = section.dataset.productSelector;
        const variant = section.querySelector(`[id^='MainProductSelect'] option[value='${notifyProduct.variantId}']`);

        if (!variant) {
          return;
        }

        const options = [variant.getAttribute("data-option-1"), variant.getAttribute("data-option-2"), variant.getAttribute("data-option-3")];

        switch (productSelectorType) {
          case "radio":
            options.forEach((option, index) => {
              const optionElements = section.querySelectorAll(`.single-option-selector__radio[name='option${index + 1}'][value='${CSS.escape(option)}'], .input-color_swatches[data-option-position='option${index + 1}'][value='${CSS.escape(option)}']`);

              optionElements.forEach((optionElement) => {
                optionElement.checked = true;
                optionElement.dispatchEvent(new Event("change"));
              });
            });

            break;

          case "select":
            options.forEach((option, index) => {
              const optionElements = section.querySelectorAll(".single-option-selector__radio");

              if (!optionElements.length) {
                return;
              }

              const select = optionElements[index];

              if (!select) {
                return;
              }

              const isAvailableOption = select.querySelector(`option[value='${CSS.escape(option)}']`);

              if (isAvailableOption) {
                select.value = option;
                select.dispatchEvent(new Event("change"));
              }
            });

            break;
        }

        const notifyFormSuccess = section.querySelector(".notify_form__success");
        const notifyFormLabel = section.querySelector(".notify_form__label");
        const notifyFormInputs = section.querySelector(".notify_form__inputs");

        notifyFormSuccess.removeAttribute("hidden");
        notifyFormLabel.setAttribute("hidden", "hidden");
        notifyFormInputs.setAttribute("hidden", "hidden");

        isToShowSuccessForm = true;
      }

      function setFormVisibility(section, productJson, isChangeEvent) {
        if (isToShowSuccessForm) {
          isToShowSuccessForm = false;

          return;
        }

        const sectionId = section.getAttribute("data-section-id");
        const productMeta = section.querySelector(".product-single__meta--wrapper");
        const formLabel = section.querySelector(".notify_form__label");
        const formMessage = section.querySelector(".notify_form_message");
        const atcButton = section.querySelector(".product-single__add-to-cart");
        const productSelect = section.querySelector("[id^='MainProductSelect']");
        const formInputs = section.querySelector(".notify_form__inputs");
        const formSuccess = section.querySelector(".notify_form__success");
        const selectedVariantId = +productSelect.value;
        const variants = productJson[sectionId] ? productJson[sectionId].variants : [];
        const isVariantSoldOut = productMeta ? productMeta.classList.contains("variant-soldout") : false;
        let selectedVariant = null;
        let isVariantAvailable = false;

        $.each(variants, function(index, value) {
          if (selectedVariantId === this.id) {
            selectedVariant = this;
            isVariantAvailable = this.available;
          }
        });

        if (formSuccess && isChangeEvent) {
          formSuccess.setAttribute("hidden", "hidden");
        }

        if (!isVariantAvailable || isVariantSoldOut) {
          const productUrl = formInputs.dataset.url;
          const formBodyMessage = formInputs.dataset.bodyMessage;

          formInputs.removeAttribute("hidden");
          formLabel.removeAttribute("hidden");
          formMessage.setAttribute("data-body", `${formBodyMessage}${productUrl}?variant=${selectedVariantId}`);
          formMessage.setAttribute("value", `${formBodyMessage}${productUrl}?variant=${selectedVariantId}`);

          if (atcButton) {
            atcButton.setAttribute("hidden", "hidden");
          }
        } else {
          formInputs.setAttribute("hidden", "hidden");
          formLabel.setAttribute("hidden", "hidden");

          if (atcButton) {
            atcButton.removeAttribute("hidden");
          }
        }
      }
    }

    BackInStock();}

  function themeBackInStockDestroy() {destroyBackInStock();

    function destroyBackInStock() {
      const backInStocks = document.querySelectorAll(".dbtfy-back_in_stock");

      backInStocks.length && backInStocks.forEach((backInStock) => {
        backInStock.remove();
      });
    }}
  /* end-dbtfy-back-in-stock */

  /* start-dbtfy-cart-countdown */
  function themeCartCountdown() {function CartCountdown() {
      const self = this;
      const $body = $("body");
      const isCartPage = document.body.classList.contains("template-cart");
      let x;

      initVariables();

      function initVariables() {
        self.dbtfy = $(".dbtfy-cart_countdown");
        self.$originalMsg = $(".dbtfy-cart_countdown_default_msg");
        self.$msgWhenOver = $(".dbtfy-cart_countdown_msg_t_over");
        self.$cartCountdown = self.dbtfy;
        self.addToCartForm = $("form[action*='/cart/add']");
        self.cartCount = self.dbtfy.data("cart-count");
        self.textMinutes = self.dbtfy.data("string-minute");
        self.textSeconds = self.dbtfy.data("string-second");
      }

      // Hide countdown section
      function hideCountdownSection() {
        self.$cartCountdown.hide();
        $body.removeClass("cart-countdown-active");
      }

      // Kill countdown
      function killCountdown() {
        clearInterval(x);
      }

      function showMessageWhenTimerIsOver() {
        self.$originalMsg.addClass("hide");
        self.$msgWhenOver.removeClass("hide");
      }

      function initializeClockCart(endtime) {
        const $minutes = $(".minutes-cart_countdown");
        const $seconds = $(".seconds-cart_countdown");

        // Set the date were counting down to
        const countDownDate = new Date(endtime).getTime();
        const now = new Date().getTime();

        if ((now - countDownDate) > 0) {
          self.$cartCountdown.show();
          showMessageWhenTimerIsOver();

          return;
        }

        // Store endtime in session
        sessionStorage.setItem("cart_endtime", endtime);

        // Update the count down every 1 second
        function cartTimer(init) {
          // Get today's date and time
          const now = new Date().getTime();

          // Find the distance between now and the count down date
          const distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (!seconds && seconds !== 0) {
            killCountdown();

            return;
          }

          // Display minutes
          if (minutes <= 0) {
            $minutes.hide();
          } else {
            $minutes.show();
            $minutes.text(minutes + self.textMinutes);
          }

          // Display seconds
          $seconds.text(seconds + self.textSeconds);

          if (init !== 1 && minutes <= 0 && seconds <= 0) {
            // Kill if the count down is finished
            killCountdown();
            showMessageWhenTimerIsOver();
          }
        }

        // Init timer
        cartTimer(1);
        clearInterval(x);
        x = setInterval(cartTimer, 1000);

        // Show timer
        self.$cartCountdown.show();
        $body.addClass("cart-countdown-active");
      }

      function initCountdown() {
        const timeMins = self.dbtfy.data("minutes");
        const currentTime = Date.parse(new Date());
        const deadline = new Date(currentTime + timeMins * 60 * 1000);
        const storedDeadline = sessionStorage.getItem("cart_endtime");

        if (window.wishlistAdded) {
          initializeClockCart(deadline);

          window.wishlistAdded = false;
        } else {
          if (sessionStorage.cart_endtime) {
            initializeClockCart(storedDeadline);
          } else {
            initializeClockCart(deadline);
          }
        }
      }

      // Session trigger
      if (sessionStorage.cart_endtime) {
        const deadline = sessionStorage.getItem("cart_endtime");

        initializeClockCart(deadline);
      } else {
        if (isCartPage && self.dbtfy.length){
          initCountdown();
        }
      }

      $body.on("ajaxCart.afterCartLoad", function(evt, cart) {
        initVariables();
        initCountdown();

        if (!cart.item_count) {
          killCountdown();
          hideCountdownSection();
        }
      });

      if (self.cartCount === 0) {
        killCountdown();
      }
    }

    CartCountdown();

    $("body").on("afterRecommendationLoad", function(evt) {
      CartCountdown();
    });}

  function themeCartCountdownDestroy() {destroyCartCountdown();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      destroyCartCountdown();
    });

    $("body").on("afterRecommendationLoad", function(evt) {
      destroyCartCountdown();
    });

    function destroyCartCountdown() {
      const cartCountdowns = document.querySelectorAll(".dbtfy-cart_countdown");

      cartCountdowns.length && cartCountdowns.forEach((cartCountdown) => {
        cartCountdown.remove();
      });
    }}
  /* end-dbtfy-cart-countdown */

  /* start-dbtfy-cart-discount */
  function themeCartDiscount() {function CartDiscount() {
      var dbtfy = $(".dbtfy-cart_discount");
      var discountInput = $(".input-cart_discount");

      if (!dbtfy.length) {
        return;
      }

      discountInput.on("keydown", function(e) {
        var RETURN_KEY_CODE = 13;

        if (e.keyCode === RETURN_KEY_CODE) {
          e.preventDefault();

          if ($(this).val() !== "") {
            $(e.target).closest("form").find("button[name='checkout']").trigger("click");
          }
        }
      });

      $(document).on("click", ".cd-apply", function(e) {
        e.preventDefault();

        var discount = $(e.target).closest(".CartDiscount").find(".input-cart_discount").val();

        if (discount !== "") {
          var checkout = $(e.target).closest("form").find("button[name='checkout']");

          if (!checkout.length) {
            checkout = $(e.target).closest("#CartDrawer").find("button[name='checkout']");
          }

          checkout.trigger("click");
        }
      });
    }

    CartDiscount();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      CartDiscount();
    });}

  function themeCartDiscountDestroy() {destroyCartDiscount();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      destroyCartDiscount();
    });

    function destroyCartDiscount() {
      const cartDiscounts = document.querySelectorAll(".dbtfy-cart_discount");

      cartDiscounts.length && cartDiscounts.forEach((cartDiscount) => {
        cartDiscount.remove();
      });
    }}
  /* end-dbtfy-cart-discount */

  /* start-dbtfy-cart-favicon */
  function themeCartFavicon() {function CartFavicon(cart) {
      const cartCount = cart ? cart.item_count : theme.variables.cartCount;

      if (theme.settings.cartFaviconImage !== "") {
        const favicon = document.getElementById("favicon");

        if (cartCount > 0) {
          favicon.setAttribute("href", theme.settings.cartFaviconImage);
        } else {
          favicon.setAttribute("href", theme.settings.faviconImage);
        }
      }
    }

    CartFavicon();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      CartFavicon(cart);
    });}
  /* end-dbtfy-cart-favicon */

  /* start-dbtfy-cart-goal */
  function themeCartGoal() {function CartGoal(cart) {
      var dbtfy = $(".dbtfy-cart_goal"),
        cgBeforeText = dbtfy.data("before-amount-text"),
        cgAfterText = dbtfy.data("after-amount-text"),
        cgGoalReachedText = dbtfy.data("goal-reached-text"),
        cgWrapper = $(".cg-wrapper"),
        cgText = $(".cg-free-shipping-text"),
        cgProgressBar = $(".cg-progress-bar"),
        cgGoal = parseFloat(dbtfy.data("goal-amount")),
        cgCartCount = parseInt(dbtfy.data("cart-total-count")),
        cgCartTotal = parseFloat(dbtfy.data("cart-total-amount"));

      if (!dbtfy.length) {
        return;
      }

      // Convert the goal amount on currency switcher
      var currencySelector = $("#currency-list-header[name='currency_code']"),
        shopCurrency = theme.strings.shopCurrency;

      if (currencySelector.length) {
        var currencyVal = currencySelector.val();

        Currency.convertAll(shopCurrency, currencyVal, "span.cart_goal_amount_new", "money");
      }

      if (currencySelector.length && currencyVal !== shopCurrency) {
        cgGoal = parseFloat(dbtfy.find("span.cart_goal_amount_new").text())*100;
      }

      if (cart) {
        cgCartTotal = cart.total_price / 100;
      }

      var cgRemainingAmount = parseFloat(cgGoal - cgCartTotal),
        cgPercentage = 0,
        cgGoalText = `<span>${cgGoalReachedText}</span>`;

      if (cgRemainingAmount > 0) {
        var moneyFormat = theme.strings.moneyFormat;

        cgPercentage = (cgGoal - cgRemainingAmount) * 100 / cgGoal;
        cgGoalText = `<span>${cgBeforeText} <span class="cg-goal-amount text-money text-secondary"><span class="money">${theme.Currency.formatMoney(cgRemainingAmount * 100, moneyFormat)}</span></span> ${cgAfterText}</span>`;
      } else {
        cgPercentage = 100;
      }

      cgText.html(cgGoalText);
      cgProgressBar.css("width", `${cgPercentage}%`);
      cgWrapper.show();

      if (cart) {
        if (!cart.item_count) {
          cgWrapper.hide();
        }
      } else {
        if (cgCartCount === 0) {
          cgWrapper.hide();
        }
      }
    }

    CartGoal();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      CartGoal(cart);
    });}

  function themeCartGoalDestroy() {destroyCartGoal();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      destroyCartGoal();
    });

    function destroyCartGoal() {
      const cartGoals = document.querySelectorAll(".dbtfy-cart_goal");

      cartGoals.length && cartGoals.forEach((cartGoal) => {
        cartGoal.remove();
      });
    }}
  /* end-dbtfy-cart-goal */

  /* start-dbtfy-cart-savings */
  function themeCartSavings() {function CartSavings() {
      if (!theme.cart) {
        document.addEventListener("dbtfy:cartLoaded", init);
      } else {
        init();
      }

      function init() {
        const cartSavings = document.querySelectorAll(".cart_savings-wrapper");
        const moneyFormat = theme.strings.moneyFormat;

        cartSavings.forEach((cartSaving) => {
          const cartDiscount = cartSaving.parentElement.querySelector(".cart-discount");
          const cartSavingsValueBlock = cartSaving.querySelector(".cart_savings-wrapper-text");
          const cartTotalWithComparePrice = +cartSaving.dataset.totalWithComparePrice;
          const cartSavingsByComparePrice = +cartSaving.dataset.totalSavingsByComparePrice;
          let totalSavings = cartSavingsByComparePrice;

          if (cartDiscount) {
            const cartDiscountValue = +cartDiscount.dataset.discountValue;

            totalSavings += cartDiscountValue;
          }

          if (totalSavings > 0) {
            cartSavingsValueBlock.innerHTML = `<span class="money">${theme.Currency.formatMoney(totalSavings, moneyFormat)}</span>`;

            const cartTotalWithDiscounts = cartTotalWithComparePrice - totalSavings;
            const cartTotalBlocks = document.querySelectorAll("[data-cart-total]");
            const cartTotalValueBlocks = document.querySelectorAll("[data-cart-total-value]");
            const cartTotalWithDiscountsFormatted = theme.Currency.formatMoney(cartTotalWithDiscounts, moneyFormat);
            const cartTotalWithCompareFormatted = theme.Currency.formatMoney(cartTotalWithComparePrice, moneyFormat);

            cartTotalBlocks.forEach((block) => {
              const existedTotalValue = block.querySelector(".cart__subtotal-compare-at");

              if (existedTotalValue) {
                block.innerHTML = "";
              }

              block.innerHTML = `<span class="cart__subtotal-discounted text-sale"><span class="money">${cartTotalWithDiscountsFormatted}</span></span> <span class="cart__subtotal-discounted text-muted text-strike"><span class="money">${cartTotalWithCompareFormatted}</span></span>`;
            });

            cartTotalValueBlocks.forEach((block) => {
              block.innerHTML = `<span class="money">${cartTotalWithDiscountsFormatted}</span>`;
            });

            cartSaving.removeAttribute("hidden");
          } else {
            cartSaving.setAttribute("hidden", "hidden");
          }
        });
      }
    }

    CartSavings();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      CartSavings();
    });

    document.addEventListener("dbtfy:cartDiscountSaved", () => {
      CartSavings();
    });

    document.addEventListener("dbtfy:discountUpdated", () => {
      CartSavings();
    });}

  function themeCartSavingsDestroy() {destroyCartSavings();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      destroyCartSavings();
    });

    function destroyCartSavings() {
      const cartSavings = document.querySelectorAll(".cart_savings-wrapper");

      cartSavings.length && cartSavings.forEach((cartSaving) => {
        cartSaving.remove();
      });
    }}
  /* end-dbtfy-cart-savings */

  /* start-dbtfy-cart-upsell */
  function themeCartUpsell() {function CartUpsell() {
      const dbtfy = document.querySelector(".cu-wrapper");

      if (!dbtfy) {
        return;
      }

      // Specific upsell
      function SpecificCartUpsell(cart) {
        removeExistedSpecificUpsells();

        const specificUpsells = dbtfy.querySelectorAll(".cu-specific-upsell");

        if (!specificUpsells.length || !cart) {
          return;
        }

        const specificUpsellsNotInCart = Array.from(specificUpsells).filter((specificUpsell) => {
          const productOfferId = +specificUpsell.dataset.offerId;

          return !cart.items.some((item) => {
            return item.product_id === productOfferId;
          });
        });

        if (!specificUpsellsNotInCart.length) {
          return;
        }

        cart.items.forEach((item, index) => {
          const cartProductId = item.product_id;

          const suitableSpecificUpsells = specificUpsellsNotInCart.filter((specificUpsell) => {
            const productTriggerId = +specificUpsell.dataset.triggerId;

            return cartProductId === productTriggerId;
          });

          if (!suitableSpecificUpsells.length) {
            return;
          }

          suitableSpecificUpsells.forEach((suitableSpecificUpsell) => {
            // Append to Cart drawer
            const drawerContainer = document.querySelector("#CartContainer .drawer__inner");

            if (drawerContainer) {
              const clonedUpsell = suitableSpecificUpsell.cloneNode(true);
              const productTrigger = drawerContainer.querySelector(`.ajaxcart_row[data-line="${index + 1}"]`);

              if (productTrigger) {
                const existedUpsellGroup = productTrigger.querySelector(".specific-upsell");

                if (!existedUpsellGroup) {
                  productTrigger.insertAdjacentHTML("beforeend", `
                    <div class="card-group spacer-top specific-upsell" data-line="${index + 1}"></div>
                  `);
                }

                const addedUpsellContainer = drawerContainer.querySelector(`.specific-upsell[data-line="${index + 1}"]`);

                if (addedUpsellContainer) {
                  addedUpsellContainer.insertAdjacentElement("beforeend", clonedUpsell);
                }
              }
            }

            // Append to Cart page
            const cartPageContainer = document.querySelector("#cartForm .dbtfy_main_cart_container");

            if (cartPageContainer) {
              const clonedUpsell = suitableSpecificUpsell.cloneNode(true);
              const productTrigger = cartPageContainer.querySelector(`.cart__row[data-line="${index + 1}"]`);

              if (productTrigger) {
                const existedUpsellGroup = productTrigger.querySelector(".specific-upsell");

                if (!existedUpsellGroup) {
                  productTrigger.insertAdjacentHTML("beforeend", `
                    <div class="card-group spacer-top specific-upsell" data-line="${index + 1}"></div>
                  `);
                }

                const addedUpsellContainer = cartPageContainer.querySelector(`.specific-upsell[data-line="${index + 1}"]`);

                if (addedUpsellContainer) {
                  addedUpsellContainer.insertAdjacentElement("beforeend", clonedUpsell);
                }
              }
            }

            theme.ajaxCart.init({
              enableQtySelectors: false
            });
          });
        });

        function removeExistedSpecificUpsells() {
          const specificUpsells = document.querySelectorAll(".specific-upsell");

          specificUpsells.forEach((specificUpsell) => {
            specificUpsell.remove();
          });
        }
      }

      // General upsell
      function GeneralCartUpsell(cart) {
        removeExistedGeneralUpsells();

        const generalUpsells = dbtfy.querySelectorAll(".cu-general-upsell");

        if (!generalUpsells.length || !cart) {
          return;
        }

        const generalUpsellsNotInCart = Array.from(generalUpsells).filter((generalUpsell) => {
          const productId = +generalUpsell.dataset.productId;

          return !cart.items.some((item) => {
            return item.product_id === productId;
          });
        });

        if (!generalUpsellsNotInCart.length) {
          return;
        }

        generalUpsellsNotInCart.forEach((generalUpsell) => {
          // Append to Cart drawer
          const drawerContainer = document.querySelector("#CartContainer .drawer__inner");

          if (drawerContainer) {
            const clonedUpsell = generalUpsell.cloneNode(true);
            const existedUpsellGroup = drawerContainer.querySelector(".ajaxcart__general-upsell");

            if (!existedUpsellGroup) {
              drawerContainer.insertAdjacentHTML("beforeend", `
                  <div class="ajaxcart__general-upsell drawer__inner-section card-group"></div>
                `);
            }

            const addedUpsellContainer = drawerContainer.querySelector(`.ajaxcart__general-upsell`);

            if (addedUpsellContainer) {
              addedUpsellContainer.insertAdjacentElement("beforeend", clonedUpsell);
            }
          }

          // Append to Cart page
          const cartPageContainer = document.querySelector("#cartForm .dbtfy_main_cart_container");

          if (cartPageContainer) {
            const clonedUpsell = generalUpsell.cloneNode(true);
            const clonedUpsellProductId = +clonedUpsell.dataset.productId;

            cartPageContainer.insertAdjacentHTML("beforeend", `
                <div class="card-group spacer-top general-upsell" data-product-id="${clonedUpsellProductId}"></div>
              `);

            const addedUpsellContainer = cartPageContainer.querySelector(`.general-upsell[data-product-id="${clonedUpsellProductId}"]`);

            if (addedUpsellContainer) {
              addedUpsellContainer.insertAdjacentElement("beforeend", clonedUpsell);
            }
          }

          theme.ajaxCart.init({
            enableQtySelectors: false
          });
        });

        function removeExistedGeneralUpsells() {
          const generalUpsells = document.querySelectorAll(".ajaxcart__general-upsell, .general-upsell");

          generalUpsells.forEach((generalUpsell) => {
            generalUpsell.remove();
          });
        }
      }

      // Show variant image
      function addListeners() {
        const selects = document.querySelectorAll(".cu-select");

        selects.forEach((select) => {
          const isEventAdded = select.hasAttribute("data-has-change-event");

          if (!isEventAdded) {
            select.addEventListener("change", () => {
              changeVariantImage(select);
              changeVariantUrl(select);
            })
          } else {
            select.setAttribute("data-has-change-event", "true");
          }
        });

        function changeVariantImage(variant) {
          const productWrapper = variant.closest(".cu-product-wrapper");
          const variantImg = variant.selectedOptions[0].dataset.variantImg;

          if (variantImg && productWrapper) {
            const variantImage = productWrapper.querySelector(".cu-variant-img");

            variantImage && variantImage.setAttribute("src", variantImg);
          }
        }

        function changeVariantUrl(variant) {
          const variantURL = variant.selectedOptions[0].dataset.variantUrl;
          const upsell = variant.closest(".cu-upsell");
          const productWrapper = variant.closest(".cu-product-wrapper");

          if (upsell) {
            const upsellProductLink = upsell.querySelector(".cu-product-name a");

            upsellProductLink && upsellProductLink.setAttribute("href", variantURL);
          }

          if (productWrapper) {
            const upsellProductLink = productWrapper.querySelector(".image-link");

            upsellProductLink && upsellProductLink.setAttribute("href", variantURL);
          }
        }

        // Add upsell product
        const cartUpsellButtons = document.querySelectorAll(".cu-addtocart-btn");
        const cartType = theme.settings.cartType;

        cartUpsellButtons.forEach((upsellButton) => {
          const isEventAdded = upsellButton.hasAttribute("data-has-click-event");

          if (!isEventAdded) {
            upsellButton.addEventListener("click", (event) => {
              event.preventDefault();

              const button = event.target.closest(".cu-addtocart-btn");
              const form = button.closest(".cu-form");

              theme.loadingState.init(button);

              if (button.classList.contains("cu-replace-offer")) {
                const closestCartRow = button.closest(".cart__row");
                const lineNumber = +closestCartRow.dataset.line;
                const currentProductQty = closestCartRow.querySelector(".cart__product-qty");

                if (currentProductQty) {
                  const currentProductQtyValue = currentProductQty.value;
                  const upsellProductQty = form.querySelector(".qty-input");

                  upsellProductQty.value = currentProductQtyValue;
                }

                $.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  dataType: "json",
                  async: false,
                  data: { "line": lineNumber, "quantity": 0 }
                });
              }

              ShopifyAPI.addItemFromForm(
                form,
                () => {
                  theme.ajaxCart.update();

                  $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
                    theme.loadingState.destroy(button);
                  });

                  document.dispatchEvent(new CustomEvent("dbtfy:formSubmitted", {
                    detail: {
                      form: form
                    }
                  }));
                },
                (XMLHttpRequest, textStatus, form) => {
                  const data = eval(`(${XMLHttpRequest.responseText})`);

                  theme.loadingState.destroy(button);

                  if (data.message && data.status === 422) {
                    button.insertAdjacentHTML("afterend",
                      `<div class="errors qty-error">${data.description}</div>`
                    );
                  }
                }
              );
            });
          } else {
            upsellButton.setAttribute("data-has-click-event", "true");
          }
        });

        const isCartPage = document.body.classList.contains("template-cart");

        if (cartType === "drawer" && isCartPage) {
          theme.ajaxCart.init();
        }
      }

      // AJAX drawer
      $("body").on("ajaxCart.afterCartLoad", function (evt, cart) {
        if (cart.items.length) {
          SpecificCartUpsell(cart);
          GeneralCartUpsell(cart);
          addListeners();
        }
      });

      // Cart page
      if ($("body").hasClass("template-cart")) {
        ShopifyAPI.getCart((cart) => {
          if (cart.items.length) {
            SpecificCartUpsell(cart);
            GeneralCartUpsell(cart);
            addListeners();
          }
        });
      }
    }

    CartUpsell();}

  function themeCartUpsellDestroy() {destroyCartUpsell();

    $("body").on("ajaxCart.afterCartLoad", function() {
      destroyCartUpsell();
    });

    function destroyCartUpsell() {
      const cartUpsells = document.querySelectorAll(".dbtfy-cart_upsell");

      cartUpsells.length && cartUpsells.forEach((cartUpsell) => {
        cartUpsell.remove();
      });
    }}
  /* end-dbtfy-cart-upsell */

  /* start-dbtfy-collection-addtocart */
  function themeCollectionAddtocart() {async function CollectionAddtocart() {
      const atcWrappers = document.querySelectorAll(".dbtfy-collection_addtocart");
      const outlinePrimaryClass = "btn-outline-primary";
      const primaryClass = "btn--primary";

      if (!atcWrappers.length) {
        return;
      }

      const cart = theme.cart;
      const cartVariantsId = cart.items.map((item) => {
        return item.variant_id;
      });

      atcWrappers.forEach(function(atcWrapper) {
        const collectionSelect = atcWrapper.querySelector(".ca-select");
        const collectionButton = atcWrapper.querySelector(".ca-button");
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari && collectionSelect) {
          fixSelectAlignment(collectionSelect);

          window.addEventListener("resize", function() {
            fixSelectAlignment(collectionSelect);
          });

          window.addEventListener("orientationchange", function() {
            fixSelectAlignment(collectionSelect);
          });
        }

        if (collectionSelect && !collectionSelect.hasAttribute("data-has-change-event")) {
          collectionSelect.addEventListener("change", function() {
            collectionButton.click();
          });
        }

        if (collectionButton && !collectionButton.hasAttribute("data-has-click-event")) {
          collectionButton.addEventListener("click", function() {
            loadingState(collectionSelect, collectionButton);
          });
        }

        if (collectionSelect) {
          collectionSelect.classList.add(outlinePrimaryClass);
          collectionSelect.classList.remove(primaryClass);

          collectionSelect.selectedIndex = 0;

          Array.from(collectionSelect.options).forEach((option) => {
            const optionVariantId = +option.value;

            if (cartVariantsId.includes(optionVariantId)) {
              collectionSelect.classList.remove(outlinePrimaryClass);
              collectionSelect.classList.add(primaryClass);

              collectionSelect.value = optionVariantId;
            }
          });

          collectionSelect.setAttribute("data-has-change-event", "true");
        }

        if (collectionButton) {
          collectionButton.setAttribute("data-has-click-event", "true");
        }
      });

      function loadingState(select, button) {
        select.classList.remove(outlinePrimaryClass);
        select.classList.add(primaryClass);

        button.classList.remove(outlinePrimaryClass);
        button.classList.add(primaryClass);
      }

      function fixSelectAlignment(select) {
        var $select = $(select);
        var optionWidth = getTextWidth($select.children(":selected").html());
        var emptySpace = $select.width() - optionWidth;

        $select.css("text-align-last", "");
        $select.css("text-indent", (emptySpace / 2) - 2);

        function getTextWidth(text) {
          var $elm = $(`<span class="tempforSize">${text}</span>`).prependTo("body");
          var elmWidth = $elm.width();

          $elm.remove();

          return elmWidth;
        }
      }
    }

    CollectionAddtocart();

    $("body").on("ajaxCart.afterCartLoad", function(evt) {
      CollectionAddtocart();
    });

    $("body").on("afterRecommendationLoad", function(evt) {
      CollectionAddtocart();
    });}

  function themeCollectionAddtocartDestroy() {document.body.classList.add("dbtfy-collection_addtocart-destroy");

    destroyCollectionAddtocart();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      destroyCollectionAddtocart();
    });

    $("body").on("afterRecommendationLoad", function(evt) {
      destroyCollectionAddtocart();
    });

    function destroyCollectionAddtocart() {
      const collectionATCs = document.querySelectorAll(".dbtfy-collection_addtocart");

      collectionATCs.length && collectionATCs.forEach((collectionATC) => {
        collectionATC.remove();
      });
    }}
  /* end-dbtfy-collection-addtocart */

  /* start-dbtfy-collection-filters */
  function themeCollectionFilters() {function CollectionFilters() {
      const collectionSection = document.querySelector(".collection-section");
      const clearAllButton = document.querySelector(".filter-clear-all");
      const drawerFooter = document.querySelector("#dbtfyCollectionFilter .drawer__footer");

      window.addEventListener("popstate", (event) => {
        history.scrollRestoration = "manual";
        filterParams();
        filterAjaxClick();
      });

      filterParams();
      showClearButtons();
      clearCategorySelectedVariants();
      clearAllSelectedVariant();
      ajaxDefaultPagination();
      choiceOfOptions();
      addFilterCategory();

      function choiceOfOptions() {
        const listFilterVariants = document.querySelectorAll(".filter-card-item label");

        listFilterVariants.forEach((filterVariant) => {
          filterVariant.addEventListener("click", (event) => {
            const parentWrapper = filterVariant.closest(".checkbox");

            if (parentWrapper.classList.contains("disabled")) {
              return;
            }

            const currentTag = filterVariant.previousElementSibling.value;
            let filterTags = [];

            if (Shopify.queryParams.constraint) {
              filterTags = Shopify.queryParams.constraint.split('+');
            }

            if (currentTag) {
              const tagPositionInArray = filterTags.indexOf(currentTag);

              if (tagPositionInArray >= 0) {
                filterTags.splice(tagPositionInArray, 1);
              } else {
                filterTags.push(currentTag);
              }
            }

            if (filterTags.length) {
              Shopify.queryParams.constraint = filterTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }

            filterAjaxClick();
          });
        });
      }

      function filterParams() {
        Shopify.queryParams = {};

        if (location.search.length) {
          const aCouples = location.search.substr(1).split('&');
          let aKeyValue = "";

          for (i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');

            if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      }

      function filterAjaxClick(baseLink) {
        delete Shopify.queryParams.page;
        const newUrl = createUrl(baseLink);

        history.pushState({
          param: Shopify.queryParams
        }, newUrl, newUrl);

        getProducts(newUrl);
      }

      function createUrl(baseLink) {
        const pageUrlParams = new URLSearchParams(Object.entries(Shopify.queryParams)).toString().replace(/%2B/g, '+');

        if (baseLink) {
          if (pageUrlParams !== "") {
            return baseLink + "?" + pageUrlParams;
          } else {
            return baseLink;
          }
        }

        if (pageUrlParams) {
          return location.pathname + "?" + pageUrlParams;
        } else {
          return location.pathname;
        }
      }

      function getProducts(url) {
        fetch(url)
          .then(function (response) {
            return response.text()
          })
          .then(function (html) {
            let newPage = new DOMParser();
            let newPageHTML = newPage.parseFromString(html, "text/html");

            updateSidebar(newPageHTML);
            updateListProducts(newPageHTML);
            updatePagination(newPageHTML);
            updateCollectionInformation(newPageHTML);
          });
      }

      function updateListProducts(page) {
        const newList = page.querySelector(".collection-list-products");
        const currentList = document.querySelector(".collection-list-products");

        currentList.innerHTML = newList.innerHTML;

        themeQuickView();
      }

      function updateSidebar(page) {
        const oldCollectionTemplateContainer = document.querySelector("#dbtfyCollectionFilter");
        const oldFilterListGroupWrapper = oldCollectionTemplateContainer.querySelector(".drawer-left__inner");
        const newCollectionTemplateContainer = page.querySelector("#dbtfyCollectionFilter");
        const newFilterListGroupWrapper = newCollectionTemplateContainer.querySelector(".drawer-left__inner");

        oldFilterListGroupWrapper.innerHTML = newFilterListGroupWrapper.innerHTML;

        showClearButtons();
        choiceOfOptions();
        clearCategorySelectedVariants();
        addFilterCategory();
      }

      function updateCollectionInformation(page) {
        const currentCollectionHeroContainer = document.querySelector(".hero-container");
        const currentCollectionHeaderContainer = document.querySelector(".simple_collection_header");
        const newCollectionHeroContainer = page.querySelector(".hero-container");
        const newCollectionHeroContainerStyles = page.querySelector(".hero-header-style");
        const newCollectionHeaderContainer = page.querySelector(".simple_collection_header");
        const mainContentContainer = document.querySelector("#mainContent");

        document.title = page.title;

        if (currentCollectionHeroContainer) {
          document.querySelector(".hero-header-style").remove();
          currentCollectionHeroContainer.remove();
        } else {
          currentCollectionHeaderContainer.remove();
        }

        if (newCollectionHeroContainer) {
          mainContentContainer.insertAdjacentElement("afterbegin", newCollectionHeroContainer);
          mainContentContainer.insertAdjacentElement("afterbegin", newCollectionHeroContainerStyles);
        } else {
          document.querySelector(".collection-controls").insertAdjacentHTML("beforebegin", newCollectionHeaderContainer.outerHTML);
        }
      }

      function updatePagination(page) {
        const currentList = document.querySelector(".collection-list-products");
        const paginationClass = (currentList.getAttribute('id') !== null) ? ".dbtfy-infinite_scroll" : ".pagination";
        const newInfiniteScrollPagination = page.querySelector(paginationClass);
        const oldInfiniteScrollPagination = document.querySelector(paginationClass);

        if (oldInfiniteScrollPagination) {
          oldInfiniteScrollPagination.remove();
        }

        if (newInfiniteScrollPagination) {
          currentList.insertAdjacentElement("afterend", newInfiniteScrollPagination);
        }

        if (currentList.getAttribute('id') !== null) {
          themeInfiniteScroll();
        } else {
          ajaxDefaultPagination();
        }
      }

      function addFilterCategory() {
        const filterCategories = document.querySelectorAll(".dbtfy-filter-list-links a");

        filterCategories.forEach((category) => {
          category.addEventListener("click", (event) => {
            event.preventDefault();

            let parentEl = category.closest("li");
            let activeEl = document.querySelector(".dbtfy-filter-list-links li.active");

            if (!parentEl.classList.contains("active")) {
              let categoryLink = category.href;

              delete Shopify.queryParams.q;
              filterAjaxClick(categoryLink);

              if (activeEl) {
                activeEl.classList.remove("active");
              }

              parentEl.classList.add("active");
            }
          });
        });
      }

      function showClearButtons() {
        const listFilterGroups = document.querySelectorAll(".dbtfy-filter-tags-group");
        let countOfActiveSections = 0;

        listFilterGroups.forEach((group) => {
          let groupInputs = group.querySelectorAll("input");
          let groupInputsArray = Array.from(groupInputs).filter((input) => input.checked === true);
          let clearButton = group.querySelector(".filter-clear");

          if (groupInputsArray.length > 0) {
            clearButton.hidden = false;
            countOfActiveSections++;
          } else {
            clearButton.hidden = true;
          }
        });

        if (countOfActiveSections) {
          if (clearAllButton) {
            clearAllButton.hidden = false;
          }

          if (drawerFooter) {
            drawerFooter.hidden = false;
          }
        } else {
          if (clearAllButton) {
            clearAllButton.hidden = true;
          }

          if (drawerFooter) {
            drawerFooter.hidden = true;
          }
        }
      }

      function clearAllSelectedVariant() {
        const listClearButtons = document.querySelectorAll(".filter-clear");

        clearAllButton && clearAllButton.addEventListener("click", (event) => {
          listClearButtons.forEach((button) => {
            button.hidden = true;
          });

          delete Shopify.queryParams.constraint;

          filterAjaxClick();
        });
      }

      function clearCategorySelectedVariants() {
        const listClearButtons = document.querySelectorAll(".filter-clear");

        listClearButtons.forEach((button) => {
          button.addEventListener("click", (event) => {
            event.preventDefault();

            let filterTags = [];
            let parrentGroup = button.closest(".dbtfy-filter-tags-group");
            let parrentGroupInputs = parrentGroup.querySelectorAll("input");
            let parrentGroupInputsArrray = Array.from(parrentGroupInputs).filter((input) => input.checked === true);

            if (Shopify.queryParams.constraint) {
              filterTags = Shopify.queryParams.constraint.split('+');
            }

            parrentGroupInputsArrray.forEach((inputElement) => {
              let tagName = inputElement.value;

              inputElement.checked = false;

              if (tagName) {
                let tagPositionInArray = filterTags.indexOf(tagName);

                if (tagPositionInArray >= 0) {
                  filterTags.splice(tagPositionInArray, 1);
                }
              }
            });

            if (filterTags.length) {
              Shopify.queryParams.constraint = filterTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }

            filterAjaxClick();
          });
        });
      }

      function ajaxDefaultPagination() {
        const paginationContainer = document.querySelector(".pagination");

        if (!paginationContainer) {
          return;
        }

        const listPages = paginationContainer.querySelectorAll(".page a");

        listPages.forEach((page) => {
          page.addEventListener("click", (event) => {
            const pageLink = page.getAttribute("href").match(/page=\d+/g);

            if (pageLink) {
              Shopify.queryParams.page = parseInt(pageLink[0].match(/\d+/g));

              if (Shopify.queryParams.page) {
                const newUrl = createUrl();

                history.pushState({
                  param: Shopify.queryParams
                }, newUrl, newUrl);

                getProducts(newUrl);

                collectionSection.scrollIntoView({block: "start", behavior: "smooth"});
              }
            }

            event.preventDefault();
          });
        })
      }
    }

    document.addEventListener("shopify:section:select", (event) => {
      if (event.detail.sectionId === "dbtfy-collection-filters") {
        timber.FilterDrawer.open(event);
      }
    });

    document.addEventListener("shopify:section:deselect", (event) => {
      if (event.detail.sectionId === "dbtfy-collection-filters") {
        timber.FilterDrawer.close(event);
      }
    });

    CollectionFilters();}

  function themeCollectionFiltersDestroy() {document.body.classList.add("dbtfy-collection-filters-destroy");

      function CollectionFiltersDestroy() {
        const filterSection = document.querySelector("#shopify-section-dbtfy-collection-filters");
        const filterButton = document.querySelector(".collection-filters-btn");
        const filterButtonContainer = filterButton ? filterButton.closest("div") : null;

        if (filterSection) {
          filterSection.remove();
        }

        if (filterButtonContainer) {
          filterButtonContainer.remove();
        }
      }

      CollectionFiltersDestroy();}
  /* end-dbtfy-collection-filters */

  /* start-dbtfy-color-swatches */
  function themeColorSwatches() {function ColorSwatches() {
      const translations = theme.strings;
      const colorSwatches = document.querySelectorAll(".input-color_swatches");

      colorSwatches.forEach((colorSwatch) => {
        if (colorSwatch.hasAttribute("data-has-change-event")) {
          return;
        }

        colorSwatch.addEventListener("change", () => {
          const swatchElementsWrapper = colorSwatch.closest(".custom_swatch_elements");
          const colorOptionLabel = swatchElementsWrapper ? swatchElementsWrapper.querySelector(".label-color_swatches") : null;
          const colorOptionLabelValue = colorOptionLabel ? colorOptionLabel.getAttribute("data-label") : null;

          const sectionId = colorSwatch.dataset.sectionId;
          const optionForm = document.getElementById(`AddToCartForm--${sectionId}`);

          if (!optionForm) {
            return;
          }

          const optionIndex = colorSwatch.dataset.index;
          const optionValue = colorSwatch.value;

          if (colorOptionLabel && colorOptionLabelValue) {
            colorOptionLabel.innerHTML = `${colorOptionLabelValue}: <span class="variant-label-option-value">${optionValue}</span>`;
          }

          const option = optionForm.querySelector(`.single-option-selector__radio[data-index="option${optionIndex}"][value="${CSS.escape(optionValue)}"]`);

          if (option) {
            option.checked = true;
            option.dispatchEvent(new Event("change"));

            return;
          }

          const select = optionForm.querySelector(`select.single-option-selector__radio[data-index="option${optionIndex}"]`);

          if (select) {
            select.value = optionValue;
            select.dispatchEvent(new Event("change"));
          }
        });

        colorSwatch.setAttribute("data-has-change-event", "true");
      });

      const colorSwatchesGrid = document.querySelectorAll(".input-color_swatches--product-grid");

      colorSwatchesGrid.forEach((swatch) => {
        swatch.addEventListener("change", () => {
          const colorName = swatch.getAttribute("value");
          const productId = swatch.dataset.productId;
          const productSelect = document.getElementById(`ProductSelect-${productId}`);
          const availableVariants = productSelect.querySelectorAll("option");
          const targetVariant = Array.from(availableVariants).find((variant) => {
            const option1 = variant.dataset.option1;
            const option2 = variant.dataset.option2;
            const option3 = variant.dataset.option3;

            return option1 === colorName || option2 === colorName || option3 === colorName;
          });

          if (!targetVariant) {
            return;
          }

          const targetVariantId = targetVariant.getAttribute("value");
          const targetVariantImageSrc = targetVariant.dataset.image;
          const targetVariantRegularPrice = targetVariant.dataset.price;
          const targetVariantCompareAtPrice = targetVariant.dataset.compareAtPrice;

          const allSameProductSwatches = document.querySelectorAll(`.input-color_swatches--product-grid[data-product-id="${productId}"][value="${colorName}"]`);

          allSameProductSwatches.forEach((productSwatch) => {
            const productGridItem = productSwatch.closest(".grid-product");
            const productImage = productGridItem ? productGridItem.querySelector(".product--image") : null;
            const productHoverImage = productGridItem ? productGridItem.querySelector(".product-hover-image img") : null;
            const productLinks = productGridItem ? productGridItem.querySelectorAll(".grid-product__image-link, .grid-product__meta") : null;
            const productPriceWrapper = productGridItem ? productGridItem.querySelector(".grid-product__price-wrap") : null;
            const productRegularPrice = productPriceWrapper ? productPriceWrapper.querySelector(".price-regular") : null;
            const productComparePrice = productPriceWrapper ? productPriceWrapper.querySelector(".price-compare") : null;

            if (productGridItem) {
              productGridItem.classList.add("cs-active");
            }

            // Change product image
            if (productImage && targetVariantImageSrc) {
              productImage.removeAttribute("srcset");
              productImage.src = targetVariantImageSrc;

              if (productHoverImage) {
                productHoverImage.src = targetVariantImageSrc;
                productHoverImage.removeAttribute("srcset");
              }
            }

            // Change product link
            if (productLinks && productLinks.length) {
              productLinks.forEach((productLink) => {
                const link = productLink.href;

                productLink.href = `${link.split("?variant=")[0]}?variant=${targetVariantId}`;
              });
            }

            // Change product price
            if (productRegularPrice || productComparePrice) {
              if (productRegularPrice) {
                productRegularPrice.innerHTML = `<span class="money">${theme.Currency.formatMoney(+targetVariantRegularPrice, theme.strings.moneyFormat)}</span>`;

                if (targetVariantCompareAtPrice && productComparePrice) {
                  productRegularPrice.classList.add("on-sale", "text-sale");
                  productRegularPrice.setAttribute("aria-label", translations.salePrice);
                } else {
                  productRegularPrice.classList.remove("on-sale", "text-sale");
                  productRegularPrice.setAttribute("aria-label", translations.regularPrice);
                }
              }

              if (targetVariantCompareAtPrice && productComparePrice) {
                productComparePrice.classList.remove("hide");
                productComparePrice.innerHTML = `<span class="money">${theme.Currency.formatMoney(+targetVariantCompareAtPrice, theme.strings.moneyFormat)}</span>`;
              } else {
                productComparePrice.classList.add("hide");
                productComparePrice.innerHTML = " ";
              }
            }

            // Convert the product price on select change based on selected currency
            var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
              shopCurrency = theme.strings.shopCurrency;

            if (currencySelector.length && shopCurrency && Currency.currentCurrency) {
              Currency.convertAll(shopCurrency, Currency.currentCurrency);
            }
          });
        });
      });
    }

    ColorSwatches();

    $(document).on("shopify:section:load", function () {
      ColorSwatches();
    });

    $("body").on("afterRecommendationLoad", function () {
      ColorSwatches();
    });}

  function themeColorSwatchesDestroy() {document.body.classList.add("dbtfy-color_swatches-destroy");

    destroyColorSwatches();

    $(document).on("shopify:section:load", function () {
      destroyColorSwatches();
    });

    $("body").on("afterRecommendationLoad", function(evt) {
      destroyColorSwatches();
    });

    function destroyColorSwatches() {
      const colorSwatches = document.querySelectorAll(".dbtfy-color_swatches");
      const optionSelectors = document.querySelectorAll(".product-form__item");

      colorSwatches.length && colorSwatches.forEach((colorSwatch) => {
        colorSwatch.remove();
      });

      optionSelectors.length && optionSelectors.forEach((optionSelector) => {
        optionSelector.removeAttribute("hidden");
      });
    }}
  /* end-dbtfy-color-swatches */

  /* start-dbtfy-cookie-box */
  function themeCookieBox() {}

  function themeCookieBoxDestroy() {}
  /* end-dbtfy-cookie-box */

  /* start-dbtfy-custom-currencies */
  function themeCustomCurrencies() {}

  function themeCustomCurrenciesDestroy() {}
  /* end-dbtfy-custom-currencies */

  /* start-dbtfy-delivery-time */
  function themeDeliveryTimeDestroy() {}
  /* end-dbtfy-delivery-time */

  /* start-dbtfy-discount-saved */
  function themeDiscountSaved() {DiscountSaved();

    function DiscountSaved() {
      const discountSavedWrappers = document.querySelectorAll(".dbtfy-discount_saved");

      if (!discountSavedWrappers.length) {
        return;
      }

      function calculateSave(productWrapper) {
        const masterSelect = productWrapper.querySelector("[id^='MainProductSelect']");

        if (!masterSelect) {
          return;
        }

        const savedAmountWrappers = productWrapper.querySelectorAll(".number-discount_saved");

        savedAmountWrappers.forEach(savedAmountWrapper => {
          savedAmountWrapper.classList.add("hide");
        });

        const variantId = masterSelect.value;

        if (!variantId) {
          return;
        }

        const discountSavedLabel = productWrapper.querySelector(`.discount_saved-${variantId}`);

        if (discountSavedLabel) {
          discountSavedLabel.classList.remove("hide");
        }
      }

      discountSavedWrappers.forEach(discountSavedWrapper => {
        const productWrapper = discountSavedWrapper.closest("[data-section-type='product-template']");

        if (!productWrapper) {
          return;
        }

        calculateSave(productWrapper);

        productWrapper.querySelectorAll(".product-form__input, .single-option-radio").forEach(optionSwitcher => {
          optionSwitcher.addEventListener("change", () => {
            calculateSave(productWrapper);
          });
        });
      });
    }}

  function themeDiscountSavedDestroy() {destroyDiscountSaved();

    function destroyDiscountSaved() {
      const discountSaved = document.querySelectorAll(".dbtfy-discount_saved");
      const prices = document.querySelectorAll(".dbtfy-sticky_addtocart .discount-sticky-price");

      discountSaved.forEach((discountSavedLabel) => {
        discountSavedLabel.remove();
      });

      prices.forEach((price) => {
        price.remove();
      });
    }}
  /* end-dbtfy-discount-saved */

  /* start-dbtfy-facebook-messenger */
  function themeFacebookMessengerDestroy() {}
  /* end-dbtfy-facebook-messenger */

  /* start-dbtfy-faq-page */
  function themeFaqPage() {function FaqPage() {
      var dbtfy = $(".dbtfy-faq_page");

      if (!dbtfy.length) {
        return;
      }

      theme.loadScript(theme.variables.jQueryUIPluginLink, () => {
        theme.loadScript(theme.variables.jQueryUIAutocompletePluginLink, initFaqPage);
      });

      function initFaqPage() {
        dbtfy.each(function() {
          var $this = $(this),
            sectionId = $this.find(".fq-main").data("section-id"),
            questions = [],
            faqItem = $this.find(".fp-item"),
            faqSearch = $this.find(`#FaqSearch-${sectionId}`);

          faqItem.each(function () {
            var faqItem = $(this),
              dataQuestion = {
                label: faqItem.attr("data-question"),
                value: faqItem.attr("data-question"),
                index: faqItem.attr("data-index")
              };

            questions.push(dataQuestion);
          });

          faqSearch.autocomplete({
            maxShowItems: 5,
            source: questions,
            search: function (event, ui) {
              $("ul.ui-autocomplete").css("max-width", `${faqSearch.outerWidth()}px`);
            },
            select: function (event, ui) {
              const $tab = $this.find(`.fp-item[data-index="${ui.item.index}"]`).find(".tab-header");

              theme.tabs.scroll($tab);
            }
          });
        });
      }
    }

    FaqPage();}

  function themeFaqPageDestroy() {document.body.classList.add("dbtfy-faq_page-destroy");

    destroyFaqPage();

    function destroyFaqPage() {
      const faqPage = document.querySelector(".dbtfy-faq_page");

      faqPage && faqPage.remove();
    }}
  /* end-dbtfy-faq-page */

  /* start-dbtfy-inactive-tab-message */
  function themeInactiveTabMessage() {function InactiveTabMessage() {
      const pageTitle = document.title;
      const firstMessage = theme.settings.dbtfyInactiveTabFirstMessage;
      const secondMessage = theme.settings.dbtfyInactiveTabSecondMessage ? theme.settings.dbtfyInactiveTabSecondMessage : pageTitle;
      const flashingEffect = !!theme.settings.dbtfyInactiveTabSecondMessage;
      const delay = theme.settings.dbtfyInactiveTabDelay * 1000;
      let isOldTitle = false;
      let timer = "";

      if (!firstMessage) {
        return;
      }

      document.addEventListener("visibilitychange", function(e) {
        const isPageActive = !document.hidden;

        if (!isPageActive) {
          if (flashingEffect) {
            changeTitle();
          } else {
            document.title = firstMessage;
          }
        } else {
          clearInterval(timer);
          document.title = pageTitle;
        }
      });

      function changeTitle() {
        timer = setInterval(function () {
          document.title = isOldTitle ? secondMessage : firstMessage;
          isOldTitle = !isOldTitle;
        }, delay);
      }
    }

    InactiveTabMessage();}
  /* end-dbtfy-inactive-tab-message */

  /* start-dbtfy-infinite-scroll */
  function themeInfiniteScroll() {function InfiniteScroll() {
      const dbtfy = document.querySelector(".dbtfy-infinite_scroll");

      if (!dbtfy) {
        return;
      }

      function callBack() {
        document.body.dispatchEvent(new CustomEvent("afterRecommendationLoad"));
      }

      const endlessType = dbtfy.dataset.endlessType;

      new Ajaxinate({
        container: "#infiniteScrollContainer",
        pagination: "#infiniteScrollPagination",
        method: endlessType,
        callback: callBack
      });

      // Hide default pagination
      const paginationBlocks = document.querySelectorAll(".pagination");

      paginationBlocks.forEach((pagination) => {
        pagination.setAttribute("hidden", "hidden");
      });
    }

    InfiniteScroll();}

  function themeInfiniteScrollDestroy() {destroyInfiniteScroll();

    function destroyInfiniteScroll() {
      document.body.classList.add("dbtfy-infinite_scroll-destroy");

      const infiniteScroll = document.querySelector(".dbtfy-infinite_scroll");

      if (!infiniteScroll) {
        return;
      }

      infiniteScroll.remove();

      if (typeof Ajaxinate === "undefined") {
        return;
      }

      const endlessInfiniteScroll = new Ajaxinate();

      endlessInfiniteScroll.destroy();
    }}
  /* end-dbtfy-infinite-scroll */

  /* start-dbtfy-instagram-feed */
  function themeInstagramFeed() {}

  function themeInstagramFeedDestroy() {}
  /* end-dbtfy-instagram-feed */

  /* start-dbtfy-inventory-quantity */
  function themeInventoryQuantity() {function InventoryQuantity() {
      const dbtfy = document.querySelector(".dbtfy-inventory_quantity");

      if (!dbtfy) {
        return;
      }

      const inventoryQuantities = document.querySelectorAll(".dbtfy-inventory_quantity:not(.sticky_inventory_quantity)");

      if (!inventoryQuantities.length) {
        return;
      }

      const isTemplateProduct = document.body.classList.contains("template-product");
      const stickyInventoryQuantity = document.querySelector(".sticky_inventory_quantity");

      inventoryQuantities.forEach((inventoryQuantity) => {
        inventoryQuantity.removeAttribute("hidden");

        const productSingle = inventoryQuantity.closest(".product-single[data-product-handle]");
        const productHandle = productSingle ? productSingle.dataset.productHandle : "";

        if (!productHandle) {
          return;
        }

        const isToShowRandomValues = inventoryQuantity.hasAttribute("data-show-random-values");

        const minQuantity = +inventoryQuantity.dataset.min;
        let maxQuantity = +inventoryQuantity.dataset.max;

        if (isToShowRandomValues) {
          const storedQuantity = +sessionStorage.getItem(`storedQuantity-${productHandle}`) || "";
          const subtractedQuantity = storedQuantity - 1;

          const randomValueBlock = inventoryQuantity.querySelector(".random-inventory_quantity");
          let randomValue = minQuantity;

          if (storedQuantity) {
            if (storedQuantity !== minQuantity) {
              randomValue = Math.max(subtractedQuantity, minQuantity);
            }
          } else {
            randomValue = Math.floor(Math.random() * (maxQuantity - minQuantity + 1)) + minQuantity;
          }

          if (randomValueBlock) {
            randomValueBlock.innerHTML = String(randomValue);
          }

          if (isTemplateProduct && stickyInventoryQuantity) {
            let stickyRandomValueBlock = stickyInventoryQuantity.querySelector(".random-inventory_quantity");

            stickyRandomValueBlock.innerHTML = String(randomValue);
            showQuantity(stickyInventoryQuantity);
          }

          sessionStorage.setItem(`storedQuantity-${productHandle}`, String(randomValue));
        }

        const productSelectors = document.querySelectorAll(".product-form__input, .single-option-radio, .input-color_swatches");

        productSelectors.forEach((productSelector) => {
          productSelector.addEventListener("change", function() {
            showQuantity(inventoryQuantity);
          });
        });

        const stickyAddToCartSelect = document.querySelector(".select-sticky_addtocart");

        if (stickyAddToCartSelect) {
          stickyAddToCartSelect.addEventListener("change", () => {
            if (isTemplateProduct && stickyInventoryQuantity) {
              showQuantity(stickyInventoryQuantity);
            }
          });

          document.addEventListener("stickyATCButtonStateChanged", () => {
            showQuantity(stickyInventoryQuantity);
          });
        }

        showQuantity(inventoryQuantity);

        if (isTemplateProduct && stickyInventoryQuantity) {
          showQuantity(stickyInventoryQuantity);
        }

        document.addEventListener("ProductPageBuilt", () => {
          showQuantity(inventoryQuantity);
        });

        $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
          showQuantity(inventoryQuantity);
        });

        function showQuantity(inventoryQuantity) {
          if (!theme.cart) {
            document.addEventListener("dbtfy:cartLoaded", init);
          } else {
            init();
            setVisibilityOfMainBlock();
          }

          function init() {
            if (!inventoryQuantity) {
              return;
            }

            const isToShowRandomValues = inventoryQuantity.hasAttribute("data-show-random-values");
            const productSingle = inventoryQuantity.closest("[data-product-handle]");
            const atcButton = productSingle.querySelector(".btn--add-to-cart, .js-add-to-cart-button");
            const quantityWrapper = inventoryQuantity.parentElement;

            if (atcButton && atcButton.matches(":disabled")) {
              inventoryQuantity.setAttribute("hidden", "hidden");

              if (quantityWrapper.children.length === 1) {
                quantityWrapper.setAttribute("hidden", "hidden");
              }

              return;
            }

            const stickySelector = inventoryQuantity.classList.contains("sticky_inventory_quantity") ? document.querySelector(".select-sticky_addtocart option:checked") : null;
            const currentVariant = productSingle.querySelector("[id^='MainProductSelect'] option:checked");
            const variantId = stickySelector ? +stickySelector.value : currentVariant ? +currentVariant.value : null;

            if (isToShowRandomValues) {
              inventoryQuantity.removeAttribute("hidden");
              quantityWrapper.removeAttribute("hidden");

              return;
            }

            const variantQuantityItems = inventoryQuantity.querySelectorAll(".quantity-item-inventory_quantity");

            if (!variantQuantityItems.length) {
              inventoryQuantity.setAttribute("hidden", "hidden");

              return null;
            }

            const suitableVariantBlocks = Array.from(variantQuantityItems).some((variantQuantity) => {
              return variantQuantity.classList.contains(`quantity-item-${variantId}-inventory_quantity`);
            });

            if (suitableVariantBlocks.length) {
              inventoryQuantity.removeAttribute("hidden");
              quantityWrapper.removeAttribute("hidden");
            } else {
              inventoryQuantity.setAttribute("hidden", "hidden");

              if (quantityWrapper.children.length === 1) {
                quantityWrapper.setAttribute("hidden", "hidden");
              }
            }

            variantQuantityItems.forEach((variantQuantity) => {
              if (variantQuantity.classList.contains(`quantity-item-${variantId}-inventory_quantity`)) {
                const lessThreshold = variantQuantity.querySelector(".quantity-item-less-threshold-inventory_quantity");
                const moreThreshold = variantQuantity.querySelector(".quantity-item-more-threshold-inventory_quantity");
                const variantQuantityValue = variantQuantity.querySelector(".quantity-item-value-inventory_quantity");
                const currentVariantInCartQuantity = theme.cart.items.reduce((acc, item) => {
                  if (item.id === variantId) {
                    return acc + item.quantity;
                  }

                  return acc;
                }, 0);

                const threshold = +variantQuantity.dataset.thresholdQty;
                const variantOriginQuantity = +variantQuantity.dataset.originQuantity;
                const ableToBuyCount = variantOriginQuantity - currentVariantInCartQuantity;

                if (ableToBuyCount > 0) {
                  if (variantQuantityValue) {
                    variantQuantityValue.innerHTML = ableToBuyCount;
                  }

                  variantQuantity.removeAttribute("hidden");

                  if (moreThreshold) {
                    if (ableToBuyCount <= threshold) {
                      lessThreshold.removeAttribute("hidden");
                      moreThreshold.setAttribute("hidden", "hidden");
                    } else {
                      lessThreshold.setAttribute("hidden", "hidden");
                      moreThreshold.removeAttribute("hidden");
                    }
                  }
                } else {
                  variantQuantity.setAttribute("hidden", "hidden");

                  if (variantQuantityItems.length === 1) {
                    inventoryQuantity.setAttribute("hidden", "hidden");
                  }
                }
              } else {
                variantQuantity.setAttribute("hidden", "hidden");
              }
            });
          }

          function setVisibilityOfMainBlock() {
            if (!inventoryQuantity) {
              return;
            }

            const inventoryQuantityVariants = inventoryQuantity.querySelectorAll(".quantity-item-inventory_quantity");
            const isVisibleSingleInventoryBlock = Array.from(inventoryQuantityVariants).some((variant) => {
              return !variant.hasAttribute("hidden");
            });

            if (isVisibleSingleInventoryBlock) {
              inventoryQuantity.removeAttribute("hidden");
            } else {
              inventoryQuantity.setAttribute("hidden", "hidden");
            }
          }
        }
      });
    }

    InventoryQuantity();}

  function themeInventoryQuantityDestroy() {destroyInventoryQuantity();

    function destroyInventoryQuantity() {
      const inventoryQuantities = document.querySelectorAll(".dbtfy-inventory_quantity");
      const productQuantities = document.querySelectorAll(".product-single__quantity");

      inventoryQuantities.forEach((inventoryQuantity) => {
        inventoryQuantity.remove();
      });

      productQuantities.forEach((productQuantity) => {
        const isQuantityEnabled = productQuantity.hasAttribute("data-quantity-enabled");
        const isQuantityBreaksEnabled = productQuantity.hasAttribute("data-quantity-breaks-enabled");

        if (!isQuantityEnabled && !isQuantityBreaksEnabled) {
          productQuantity.remove();
        }
      });
    }}
  /* end-dbtfy-inventory-quantity */

  /* start-dbtfy-linked-options */
  function themeLinkedOptions() {}
  /* end-dbtfy-linked-options */

  /* start-dbtfy-live-view */
  function themeLiveView() {}

  function themeLiveViewDestroy() {}
  /* end-dbtfy-live-view */

  /* start-dbtfy-mega-menu */
  function themeMegaMenu() {function MegaMenu() {
      var megamenuItems = $(".mm-item");

      if (!megamenuItems.length) {
        return;
      }

      // Insert mega menu items in header
      megamenuItems.each(function() {
        var $this = $(this);
        var insertPosition = $this.data("position");
        var menuNavItem = $(".nav-container-menu .site-nav__item").eq(insertPosition - 1);

        $this.insertBefore(menuNavItem);
      });
    }

    $(document).on("shopify:section:load", function () {
      MegaMenu();
      theme.dropdown();
    });

    MegaMenu();}

  function themeMegaMenuDestroy() {document.body.classList.add("dbtfy-mega_menu-destroy");

    destroyMegaMenu();

    $(document).on("shopify:section:load", function () {
      destroyMegaMenu();
    });

    function destroyMegaMenu() {
      const megaMenus = document.querySelectorAll(".dbtfy-mega_menu");

      megaMenus.length && megaMenus.forEach((megaMenu) => {
        megaMenu.remove();
      });
    }}
  /* end-dbtfy-mega-menu */

  /* start-dbtfy-menu-bar */
  function themeMenuBarDestroy() {destroyMenuBars();

    function destroyMenuBars() {
      const menus = document.querySelectorAll(".dbtfy-menu_bar");

      menus.length && menus.forEach((menu) => {
        menu.remove();
      });
    }}
  /* end-dbtfy-menu-bar */

  /* start-dbtfy-newsletter-popup */
  function themeNewsletterPopup() {}

  function themeNewsletterPopupDestroy() {}
  /* end-dbtfy-newsletter-popup */

  /* start-dbtfy-order-feedback */
  function themeOrderFeedback() {function OrderFeedback() {
      const dbtfySelector = ".dbtfy-order_feedback";
      const feedbackSelectSelector = ".order-feedback"
      const dbtfy = document.querySelectorAll(dbtfySelector);

      if (!dbtfy.length) {
        return;
      }

      const feedbackSelects = document.querySelectorAll(feedbackSelectSelector);
      const checkoutButtons = document.querySelectorAll('[name="checkout"], [name="goto_pp"], [name="goto_gc"]');
      const selectors = {
        feedbackSelectError: ".of-error",
        otherInputElement: ".order-feedback-other",
        otherInputError: ".of-other-error",
        otherFormWrapper: ".other-form-wrapper"
      }

      function showOrHideForm(formElement) {
        let selectOtherValue = formElement.dataset.otherField;
        let parentElement = formElement.closest(dbtfySelector);
        const otherForm = parentElement.querySelector(selectors.otherFormWrapper);

        if (!selectOtherValue) {
          otherForm && otherForm.setAttribute("hidden", "hidden");

          return;
        }

        if (formElement.value === selectOtherValue) {
          otherForm && otherForm.removeAttribute("hidden");
        } else {
          otherForm && otherForm.setAttribute("hidden", "hidden");
        }
      }

      function checkFormElement(formElement, formErrorElement) {
        let parentElement = formElement.closest(dbtfySelector);

        if (formElement.value.length === 0) {
          formElement.classList.add('error');
          parentElement.querySelector(formErrorElement).removeAttribute("hidden");
        } else {
          if (formElement.classList.contains('error')) {
            formElement.classList.remove('error');
            parentElement.querySelector(formErrorElement).setAttribute("hidden", "hidden");
          }

          checkoutButtons.length && checkoutButtons.forEach((checkoutButton) => {
            checkoutButton.removeAttribute("disabled");
          });
        }
      }

      feedbackSelects.forEach((feedbackSelect) => {
        let inputElement = feedbackSelect.closest(dbtfySelector).querySelector(selectors.otherInputElement);
        const selectAttributeName = feedbackSelect.getAttribute("name");
        const inputAttributeName = inputElement ? inputElement.getAttribute("name") : null;

        feedbackSelect.addEventListener("change", function() {
          const selectedValue = feedbackSelect.value;
          const optionWithSelectedValue = feedbackSelect.options[feedbackSelect.selectedIndex];
          let validation = feedbackSelect.dataset.selectRequired;

          showOrHideForm(feedbackSelect);

          if (validation === "true") {
            checkFormElement(feedbackSelect, selectors.feedbackSelectError);
          }

          // Sync both select value
          feedbackSelects.length && feedbackSelects.forEach((secondFeedbackSelect) => {
            if (secondFeedbackSelect !== feedbackSelect) {
              secondFeedbackSelect.selectedIndex = feedbackSelect.selectedIndex;

              let validation = secondFeedbackSelect.dataset.selectRequired;

              showOrHideForm(secondFeedbackSelect);

              if (validation === "true") {
                checkFormElement(secondFeedbackSelect, selectors.feedbackSelectError);
              }
            }
          });

          // Store orderFeedback in session
          localStorage.setItem("orderFeedback", selectedValue);

          // Update cart attribute
          jQuery.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: `${selectAttributeName}=${selectedValue}`,
            dataType: 'json',
            success: function(cart) {
              if (!optionWithSelectedValue.hasAttribute("data-is-other-option")) {
                const otherOption = feedbackSelect.querySelector("[data-is-other-option]");

                if (otherOption) {
                  const inputAttributeName = otherOption.dataset.name;

                  jQuery.post("/cart/update.js", `${inputAttributeName}=`);
                }

                $(selectors.otherInputElement).val("");
              }
            }
          });
        });

        inputElement && inputElement.addEventListener("input", function() {
          checkFormElement(inputElement, selectors.otherInputError);

          // Update cart other attribute
          if (inputElement.value.length !== 0 && inputAttributeName) {
            jQuery.post('/cart/update.js', `${inputAttributeName}=${inputElement.value}`);
          }
        });

        if (localStorage.orderFeedback) {
          feedbackSelect.value = localStorage.getItem("orderFeedback");
          showOrHideForm(feedbackSelect);
        }

        // Update cart attribute
        jQuery.post('/cart/update.js', `${selectAttributeName}=${feedbackSelect.value}`);
      });

      // Sync other input value
      $(selectors.otherInputElement).keyup(function() {
        $(selectors.otherInputElement).val($(this).val());
      });

      checkoutButtons.forEach(function(checkoutButton) {
        checkoutButton.addEventListener("click", function(evt) {
          const formFeedback = checkoutButton.closest("form");
          const formFeedbackElement = formFeedback ? formFeedback.querySelector(dbtfySelector) : null;

          if (!formFeedbackElement) {
            return;
          }

          const formValidation = formFeedbackElement.dataset.selectRequired;

          if (formValidation === "true") {
            const feedbackSelect = formFeedback.querySelector(feedbackSelectSelector);
            const inputElement = feedbackSelect.closest(dbtfySelector).querySelector(selectors.otherInputElement);
            const selectOtherValue = feedbackSelect.dataset.otherField;
            let validated = true;

            if (feedbackSelect.value.length === 0) {
              checkFormElement(feedbackSelect, selectors.feedbackSelectError);
              validated = false;
            }

            if (selectOtherValue && feedbackSelect.value === selectOtherValue) {
              if (inputElement && inputElement.value.length === 0) {
                checkFormElement(inputElement, selectors.otherInputError);
                validated = false;
              }
            }

            if (!validated) {
              evt.preventDefault();
              evt.stopPropagation();

              window.orderFeedbackHasErrors = true;

              setTimeout(() => {
                theme.loadingState.destroy(checkoutButton);
              }, 0);

              if (window.agreeToTCHasErrors) {
                window.agreeToTCHasErrors = false;

                return;
              }

              // Scroll to warning message
              const $drawer = $(checkoutButton).closest("#CartDrawer");
              const isCartPage = document.body.classList.contains("template-cart");

              if ($drawer.hasClass("js-drawer-open")) {
                const $drawerHeader = $drawer.find(".drawer__header");
                const $drawerInner = $drawer.find(".drawer__inner");
                const $closestFeedbackBlock = $drawerInner.find(dbtfySelector);
                const $cartCountdownSticky = $drawerInner.find(".dbtfy-cart_countdown.sticky");

                const feedbackBlockOffsetTop = $closestFeedbackBlock.offset() ? $closestFeedbackBlock.offset().top : 0;
                const drawerHeaderHeight = $drawerHeader.height() || 0;
                const cartCountdownStickyHeight = $cartCountdownSticky.height() || 0;
                const windowScrollTop = $(window).scrollTop();
                const drawerInnerScrollTop = $drawerInner.scrollTop();
                const visibleOffset = 10;

                $drawerInner.animate({
                  scrollTop: feedbackBlockOffsetTop - drawerHeaderHeight - cartCountdownStickyHeight - windowScrollTop + drawerInnerScrollTop - visibleOffset
                }, 500);
              } else if (isCartPage) {
                const isStickyHeader = document.body.classList.contains("sticky-header");
                const $header = $(".header-section");
                const $cartForm = $("#cartForm");
                const $closestFeedbackBlock = $cartForm.find(dbtfySelector);
                const feedbackBlockOffsetTop = $closestFeedbackBlock.offset() ? $closestFeedbackBlock.offset().top : 0;
                const headerStickyHeight = isStickyHeader ? $header.height() : 0;
                const visibleOffset = 15;

                $("html, body").animate({
                  scrollTop: feedbackBlockOffsetTop - headerStickyHeight - visibleOffset
                }, 500);
              }
            }
          } else {
            if (window.agreeToTCHasErrors) {
              window.agreeToTCHasErrors = false;
            } else {
              formFeedback.submit();
            }
          }
        });
      });
    }

    OrderFeedback();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      OrderFeedback();
    });}

  function themeOrderFeedbackDestroy() {destroyOrderFeedbacks();

    $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
      destroyOrderFeedbacks();
    });

    function destroyOrderFeedbacks() {
      const orderFeedbacks = document.querySelectorAll(".dbtfy-order_feedback");

      orderFeedbacks.forEach((orderFeedbackBlock) => {
        orderFeedbackBlock.remove();
      });
    }}
  /* end-dbtfy-order-feedback */

  /* start-dbtfy-order-tracking */
  function themeOrderTracking() {function OrderTracking() {
      const trackingNumberForm = document.getElementById("ot-form");
      const trackingNumberField = document.getElementById("ot-num");
      const trackingNumberButton = document.getElementById("ot-btn");

      if (!trackingNumberForm) {
        return;
      }

      theme.loadScript(theme.variables.trackingPluginLink, init);

      function init() {
        trackingNumberForm.addEventListener("submit", function(e) {
          e.preventDefault();

          const trackingNumber = trackingNumberField.value;

          if (trackingNumber === "") {
            alert("Enter your number.");

            theme.loadingState.destroy(trackingNumberButton);

            setTimeout(() => {
              trackingNumberButton.removeAttribute("disabled");
            }, 0);

            return;
          }

          // Add loading icon
          trackingNumberButton.setAttribute("disabled", "disabled");
          trackingNumberButton.classList.add("btn--loading");

          // Tracking function
          try {
            initOrderTracking(trackingNumber);
          } finally {
            setTimeout(function() {
              trackingNumberButton.removeAttribute("disabled");
              trackingNumberButton.classList.remove("btn--loading");
            }, 1500);
          }
        });
      }

      function initOrderTracking(trackingNumber) {
        YQV5.trackSingle({
          // Required, Specify the container ID of the carrier content.
          YQ_ContainerId: "ot-container",
          // Optional, specify tracking result height, max height 800px, default is 560px.
          YQ_Height: 560,
          // Optional, select carrier, default to auto identify.
          YQ_Fc: "0",
          // Optional, specify UI language, default language is automatically detected based on the browser settings.
          YQ_Lang: "en",
          // Required, specify the number needed to be tracked.
          YQ_Num: trackingNumber
        });
      }
    }

    OrderTracking();}

  function themeOrderTrackingDestroy() {destroyOrderTracking();

    function destroyOrderTracking() {
      const orderTracking = document.querySelector(".dbtfy-order_tracking");

      orderTracking && orderTracking.remove();
    }}
  /* end-dbtfy-order-tracking */

  /* start-dbtfy-page-transition */
  function themePageTransition() {}

  function themePageTransitionDestroy() {}
  /* end-dbtfy-page-transition */

  /* start-dbtfy-page-speed-booster */
  function themePageSpeedBooster() {function PageSpeedBooster() {
      theme.loadScript(theme.variables.speedBoosterPluginLink);
    }

    PageSpeedBooster();}
  /* end-dbtfy-page-speed-booster */

  /* start-dbtfy-pricing-table */
  function themePricingTableDestroy() {destroyPricingTable();

    function destroyPricingTable() {
      const pricingTables = document.querySelectorAll(".dbtfy-pricing_table");

      pricingTables.length && pricingTables.forEach((pricingTable) => {
        pricingTable.remove();
      });
    }}
  /* end-dbtfy-pricing-table */

  /* start-dbtfy-product-bullet-points */
  function themeProductBulletPoints() {function ProductBulletPoints() {
      const dbtfy = document.querySelector(".dbtfy-product_bullet_points");

      if (!dbtfy) {
        return;
      }

      // Get all bullet points
      const bulletPoints = dbtfy.querySelectorAll(".pbp-point");

      if (!bulletPoints.length) {
        return;
      }

      // Get product sections on current page
      const productsOnPage = document.querySelectorAll(".product-single[data-product-handle]");
      const productsWithBulletsAssigned = {};

      productsOnPage.length && productsOnPage.forEach((product) => {
        const productInfo = product.querySelector(".product-info-JSON");
        const productJSON = productInfo ? JSON.parse(productInfo.innerHTML) : null;

        if (!productJSON) {
          return;
        }

        const productHandle = productJSON.handle;
        const productType = productJSON.type;
        const productTags = productJSON.tags;
        const productCollections = productJSON.collections;

        bulletPoints.forEach((bulletPoint) => {
          const bulletProductTypes = bulletPoint.dataset.productTypes ? bulletPoint.dataset.productTypes.split(","): [];
          const bulletProductTags = bulletPoint.dataset.productTags ? bulletPoint.dataset.productTags.split(",") : [];
          const bulletProductHandle = bulletPoint.dataset.productHandle;
          const bulletProductCollection = bulletPoint.dataset.productCollection;

          // If all settings are empty
          if (!bulletProductTypes.length && !bulletProductTags.length && !bulletProductHandle && !bulletProductCollection) {
            addPointToProduct(productHandle, bulletPoint);
          }

          // Check for type
          bulletProductTypes.length && bulletProductTypes.forEach((bulletProductType) => {
            if (bulletProductType === productType) {
              addPointToProduct(productHandle, bulletPoint);
            }
          });

          // Check for tags
          bulletProductTags.length && bulletProductTags.forEach((bulletProductTag) => {
            if (productTags.includes(bulletProductTag)) {
              addPointToProduct(productHandle, bulletPoint);
            }
          });

          // Check for handle
          if (bulletProductHandle === productHandle) {
            addPointToProduct(productHandle, bulletPoint);
          }

          // Check for collections
          productCollections.length && productCollections.forEach((productCollection) => {
            if (productCollection.handle === bulletProductCollection) {
              addPointToProduct(productHandle, bulletPoint);
            }
          });
        });
      });

      // If no bullet points to insert
      if (!Object.keys(productsWithBulletsAssigned).length) {
        return;
      }

      // Add points to target products
      const bulletPointsPosition = dbtfy.dataset.position;

      for (const [productHandle, bulletPoints] of Object.entries(productsWithBulletsAssigned)) {
        const productSingle = document.querySelector(`.product-single[data-product-handle="${productHandle}"]`);

        if (!productSingle) {
          return;
        }

        let blockToInsertBulletAfter = null;
        const additionalClasses = [];

        switch (bulletPointsPosition) {
          case "under-product-price":
            blockToInsertBulletAfter = productSingle.querySelector(".price-container");

            break;

          case "under-addtocart-button":
            blockToInsertBulletAfter = productSingle.querySelector(".product-single__add-to-cart");
            additionalClasses.push("text-center");

            break;
        }

        if (!blockToInsertBulletAfter) {
          return;
        }

        const productBulletPointsList = document.createElement("ul");

        productBulletPointsList.classList.add("pbp-points", "inline-list", ...additionalClasses);

        bulletPoints.forEach((bulletPoint) => {
          productBulletPointsList.insertAdjacentElement("beforeend", bulletPoint.cloneNode(true));
        });

        blockToInsertBulletAfter.insertAdjacentElement("afterend", productBulletPointsList);
      }

      function addPointToProduct(productHandle, bulletPoint) {
        if (!productsWithBulletsAssigned[productHandle]) {
          productsWithBulletsAssigned[productHandle] = [bulletPoint];
        } else {
          if (!productsWithBulletsAssigned[productHandle].includes(bulletPoint)) {
            productsWithBulletsAssigned[productHandle].push(bulletPoint);
          }
        }
      }
    }

    ProductBulletPoints();}

  function themeProductBulletPointsDestroy() {destroyProductBulletPoints();

    function destroyProductBulletPoints() {
      const bulletPoints = document.querySelector(".dbtfy-product_bullet_points");

      bulletPoints && bulletPoints.remove();
    }}
  /* end-dbtfy-product-bullet-points */

  /* start-dbtfy-product-image-crop */
  function themeProductImageCropDestroy() {document.body.classList.add("dbtfy-product_image_crop-destroy");}
  /* end-dbtfy-product-image-crop */

  /* start-dbtfy-product-tabs */
  function themeProductTabsDestroy() {destroyProductTabs();

    function destroyProductTabs() {
      const productTabs = document.querySelectorAll(".dbtfy-product_tabs");

      productTabs.length && productTabs.forEach((productTab) => {
        productTab.remove();
      });
    }}
  /* end-dbtfy-product-tabs */

  /* start-dbtfy-quantity-breaks */
  function themeQuantityBreaks() {function QuantityBreaks() {
      const dbtfy = document.querySelector(".dbtfy-quantity_breaks");

      if (!dbtfy) {
        return;
      }

      const singleBreakText = dbtfy.dataset.singleBreakText;
      const moreDiscountBeforeQuantityText = dbtfy.dataset.moreDiscountBeforeQuantityText;
      const moreDiscountAfterQuantityText = dbtfy.dataset.moreDiscountAfterQuantityText;
      const moreDiscountAfterPercentageText = dbtfy.dataset.moreDiscountAfterPercentageText;
      const highestDiscountText = dbtfy.dataset.highestDiscountText;
      const quantityBreaks = dbtfy.querySelectorAll(".qb-quantity");
      const quantityWrappers = document.querySelectorAll(".product-single__form .product-single__quantity");
      const atcButtons = document.querySelectorAll(".product-single__form .product-single__add-to-cart");
      const quantityLabel = document.querySelector(".product-single__quantity label");
      const productSelectors = document.querySelectorAll(".product-form__input, .single-option-radio, .input-color_swatches");
      const formsWithDefaultVariants = document.querySelectorAll(".product-single__form--no-variants");
      const productsJSON = {};
      const quantityLabelText = theme.strings.quantityLabel;
      const moneyFormat = theme.strings.moneyFormat;

      if (!quantityBreaks.length) {
        return;
      }

      if (quantityLabel) {
        quantityLabel && quantityLabel.removeAttribute("hidden");
      }

      if (quantityWrappers.length) {
        quantityWrappers.forEach((quantityWrapper) => {
          const clonedDbtfy = dbtfy.cloneNode(true);
          const quantities = clonedDbtfy.querySelectorAll(".qb-quantity");
          const container = quantityWrapper.querySelector(".qty-container");
          const productSection = quantityWrapper.closest("[data-section-type='product-template']");
          const productSectionId = productSection.dataset.sectionId;
          const form = productSection.querySelector(".product-single__form");
          const productJSONScript = document.getElementById(`ProductJson-${productSectionId}`);

          if (productJSONScript) {
            changeQuantityBreaksId(quantities, productSectionId);
            saveQuantityBreaksDiscounts(quantities);

            theme.removeAllChildNodes(container);
            clonedDbtfy.removeAttribute("hidden");
            container.insertAdjacentElement("beforeend", clonedDbtfy);
            productsJSON[productSectionId] = JSON.parse(productJSONScript.innerHTML);
          }

          if (form) {
            form.addEventListener("submit", () => {
              applyQuantityBreakDiscount(form);
            });
          }
        });
      } else {
        atcButtons.forEach((atcButton) => {
          const clonedDbtfy = dbtfy.cloneNode(true);
          const quantities = clonedDbtfy.querySelectorAll(".qb-quantity");
          const container = document.createElement("div");
          const productSection = atcButton.closest("[data-section-type='product-template']");
          const productSectionId = productSection.dataset.sectionId;
          const productJSONScript = document.getElementById(`ProductJson-${productSectionId}`);

          changeQuantityBreaksId(quantities, productSectionId);
          saveQuantityBreaksDiscounts(quantities);

          container.classList.add("qty-container");
          container.insertAdjacentHTML(`
              <label for="Quantity" class="quantity-break-label">${quantityLabelText}</label>
              ${clonedDbtfy.innerHTML}
            `);

          if (productJSONScript) {
            productsJSON[productSectionId] = JSON.parse(productJSONScript.innerHTML);
          }

          atcButton.insertAdjacentElement("beforebegin", container);
        });
      }

      productSelectors.length && productSelectors.forEach((productSelector) => {
        productSelector.addEventListener("change", function(e) {
          updateQuantityBreaks(e);
        });

        updateQuantityBreaks({
          target: productSelector
        });
      });

      formsWithDefaultVariants.forEach((form) => {
        updateQuantityBreaks({
          target: form
        });
      });

      function saveQuantityBreaksDiscounts(quantities) {
        const discounts = [];

        quantities.forEach((quantity) => {
          const input = quantity.querySelector("input");
          const breakCount = +input.value;
          const discountName = input.dataset.discountCode;
          const discountType = input.dataset.discountType;
          const discountAmount = +input.dataset.discountAmount;

          if (discountName && discountType && discountAmount) {
            discounts.push({
              breakCount: breakCount,
              name: discountName,
              type: discountType,
              amount: discountAmount
            });
          }
        });

        if (discounts.length) {
          // Sort from min to max by breakCount field
          discounts.sort((a, b) => a.breakCount - b.breakCount);

          sessionStorage.setItem("quantity-breaks-discounts", JSON.stringify(discounts));
        }
      }

      function changeQuantityBreaksId(quantities, productSectionId) {
        quantities.forEach((quantity) => {
          const label = quantity.querySelector("label");
          const input = quantity.querySelector("input");

          label.setAttribute("for", `${input.id}-${productSectionId}`);
          input.setAttribute("id", `${input.id}-${productSectionId}`);
        });
      }

      function updateQuantityBreaks(e) {
        const productSection = e.target.closest("[data-section-type='product-template']");

        if (!productSection) {
          return;
        }

        const variantSelect = productSection.querySelector("[id^='MainProductSelect']");
        const currentVariant = variantSelect.querySelector("option:checked");
        const variantId = currentVariant ? +currentVariant.value : null;
        const productSectionId = productSection.dataset.sectionId;
        const quantityBreaks = productSection.querySelectorAll(".qb-quantity");
        const productJSON = productsJSON[productSectionId];

        if (!productJSON) {
          return;
        }

        const variant = productJSON.variants.find((variant) => {
          return variant.id === variantId;
        });

        if (!variant) {
          return;
        }

        quantityBreaks.forEach((quantityBreak) => {
          const label = quantityBreak.querySelector("label");
          const input = quantityBreak.querySelector("input");
          const breakCount = +input.value;
          const discountType = input.dataset.discountType;
          const discountAmount = +input.dataset.discountAmount;
          let price = variant.price;
          let comparePrice = variant.compare_at_price;
          let labelText = singleBreakText;
          let savedAmount = "";

          // Replace _COUNT_ variable
          labelText = labelText.replace("_COUNT_", breakCount);

          // Replace _PRICE_ variable
          if (breakCount > 1) {
            comparePrice = price * breakCount;

            switch (discountType) {
              case "$":
                price = comparePrice - (discountAmount * 100);
                savedAmount = `<span class="money">${theme.Currency.formatMoney(discountAmount * 100, moneyFormat)}</span>`;

                break;

              case "%":
                price = comparePrice - (comparePrice / 100 * discountAmount);
                savedAmount = `${discountAmount}%`;

                break;
            }
          }

          if (price < 0 || comparePrice < 0) {
            quantityBreak.setAttribute("data-invalid-value", "true");
          } else {
            quantityBreak.removeAttribute("data-invalid-value");
          }

          if (comparePrice) {
            labelText = labelText.replace("_PRICE_", `
                <span class="qb-price text-money">
                  <span class="qb-discounted-price on-sale text-sale">
                    <span class="money">
                      ${theme.Currency.formatMoney(price, moneyFormat)}
                    </span>
                  </span>

                  <span class="qb-original-price text-strike text-muted">
                    <span class="money">
                      ${theme.Currency.formatMoney(comparePrice, moneyFormat)}
                    </span>
                  </span>
                </span>
              `);
          } else {
            labelText = labelText.replace("_PRICE_", `
                <span class="qb-price text-money">
                  <span class="money">
                    ${theme.Currency.formatMoney(price, moneyFormat)}
                  <span>
                </span>
              `);
          }

          // Replace _SAVED_AMOUNT_ variable
          if (breakCount > 1) {
            const savedAmountText = theme.strings.saveLabel.replace("\{\{ saved_amount \}\}", savedAmount);

            labelText = labelText.replace("_SAVED_AMOUNT_", `
                <span class="badge qb-saved-amount">
                  ${savedAmountText}
                </span>
              `);
          } else {
            labelText = labelText.replace("_SAVED_AMOUNT_", "");
          }

          label.innerHTML = labelText;
        });

        hideUnnecessaryBreaks();

        // Convert the quantity breaks amount on custom currency switcher
        var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
          shopCurrency = theme.strings.shopCurrency;

        if (currencySelector.length) {
          Currency.convertAll(shopCurrency, Currency.currentCurrency, ".qb-price .money, .qb-saved-amount .money");
        }
      }

      function hideUnnecessaryBreaks() {
        if (!theme.cart) {
          document.addEventListener("dbtfy:cartLoaded", init);
        } else {
          init();
        }

        function init() {
          const quantityBreaksWrappers = document.querySelectorAll(".dbtfy-quantity_breaks");

          quantityBreaksWrappers.forEach((quantityBreak) => {
            const quantities = quantityBreak.querySelectorAll(".qb-quantity");
            const productSection = quantityBreak.closest("[data-section-type='product-template']");

            if (!productSection) {
              return;
            }

            const variantSelect = productSection.querySelector("[id^='MainProductSelect']");
            const currentVariant = variantSelect.querySelector("option:checked");
            const variantId = +currentVariant.value;
            const productSectionId = productSection.dataset.sectionId;
            const productJSON = productsJSON[productSectionId];

            if (!productJSON) {
              return;
            }

            const variantJSON = productJSON.variants.find((variant) => {
              return variant.id === variantId;
            });

            if (!variantJSON) {
              return;
            }

            const cart = theme.cart;
            const variantInventoryQuantity = +currentVariant.dataset.inventoryQuantity || 0;
            const variantInventoryPolicy = currentVariant.dataset.inventoryPolicy;
            const currentVariantInCartQuantity = cart.items.reduce((acc, item) => {
              if (item.id === variantId) {
                return acc + item.quantity;
              }

              return acc;
            }, 0);

            const ableToBuyCount = variantInventoryQuantity - currentVariantInCartQuantity;

            if (variantJSON.available) {
              // If track quantity is enabled
              if (variantJSON.inventory_management === "shopify" && variantInventoryPolicy !== "continue") {
                showQuantityBreaks(ableToBuyCount, quantities);
              } else {
                showQuantityBreaks(30, quantities);
              }
            } else {
              showQuantityBreaks(0, quantities);
            }
          });
        }

        function showQuantityBreaks(availableAmount, quantityBreaks) {
          quantityBreaks.forEach((quantityBreak) => {
            const input = quantityBreak.querySelector("input");
            const breakCount = +input.value;

            if (breakCount === 1) {
              input.checked = true;
            }

            if (breakCount > availableAmount || quantityBreak.hasAttribute("data-invalid-value")) {
              quantityBreak.setAttribute("hidden", "hidden");
            } else {
              quantityBreak.removeAttribute("hidden");
            }
          });
        }
      }

      function applyQuantityBreakDiscount(form) {
        const activeQuantityBreak = form.querySelector(".qb-quantity input:checked");
        const breakCount = +activeQuantityBreak.value;
        const discountCode = activeQuantityBreak.dataset.discountCode;
        const discountType = activeQuantityBreak.dataset.discountType;
        const discountAmount = +activeQuantityBreak.dataset.discountAmount;

        if (discountCode && discountType && discountAmount) {
          theme.discountCode.addDiscount(discountCode, discountType, discountAmount, {
            breakCount: breakCount,
            role: "quantity-breaks"
          });
        }
      }

      function breaksOnCartUpdate(cart) {
        const cartTotal = cart.total_price;
        const breaksDiscounts = JSON.parse(sessionStorage.getItem("quantity-breaks-discounts"));

        if (!breaksDiscounts) {
          return;
        }

        const suitableBreaksDiscounts = [];
        const cartItemsCount = cart.item_count;

        breaksDiscounts.forEach((discount) => {
          const breakCount = discount.breakCount;
          const discountName = discount.name;
          const discountType = discount.type;
          const discountAmount = discount.amount;

          if (cartItemsCount >= breakCount) {
            suitableBreaksDiscounts.push({
              name: discountName,
              type: discountType,
              amount: discountAmount
            });
          }
        });

        // Remove all existed Quantity breaks discounts
        const discounts = theme.discountCode.getStoredDiscounts();

        breaksDiscounts.forEach((discount) => {
          const storedDiscount = discounts.find((storedDiscount) => {
            return storedDiscount.name === discount.name;
          });

          if (storedDiscount && storedDiscount.role === "quantity-breaks") {
            theme.discountCode.removeDiscount(discount.name);
          }
        });

        // Get max valuable Quantity breaks discount
        let discountWithMaxValue = null;
        let maxValue = 0;

        suitableBreaksDiscounts.forEach((suitableDiscount) => {
          const savedMoney = getSavedMoney(suitableDiscount, cart);

          if (!discountWithMaxValue || savedMoney >= maxValue) {
            if (savedMoney <= cartTotal) {
              discountWithMaxValue = suitableDiscount;
              maxValue = savedMoney;
            }
          }
        });

        if (discountWithMaxValue) {
          const isDiscountWithMaxValueInDiscounts = theme.discountCode.hasDiscount(discountWithMaxValue.name);

          // Quantity breaks discount not in discounts
          if (!isDiscountWithMaxValueInDiscounts && Object.keys(discountWithMaxValue).length > 0) {
            const discountName = discountWithMaxValue.name;
            const discountType = discountWithMaxValue.type;
            const discountAmount = discountWithMaxValue.amount;

            theme.discountCode.addDiscount(discountName, discountType, discountAmount, {
              role: "quantity-breaks"
            });
          }
        }

        hideUnnecessaryBreaks();
        showQuantityBreaksMessageInCart(cart);

        theme.discountCode.init();
      }

      function showQuantityBreaksMessageInCart(cart) {
        const ajaxCartSubtotal = document.querySelector("#CartDrawer .cart__total-price-info");
        const cartPageCartSubtotal = document.querySelector("#cartForm .cart__total-price-info");
        const discounts = theme.discountCode.getStoredDiscounts();
        const mostValuableDiscount = theme.discountCode.getMostValuableDiscount(discounts, cart);
        const mostValuableDiscountSavedAmount = getSavedMoney(mostValuableDiscount, cart);
        const quantityBreaksDiscounts = JSON.parse(sessionStorage.getItem("quantity-breaks-discounts"));
        const cartItemsCount = cart.item_count;
        const cartTotal = cart.total_price;

        let message = `<div class="dbtfy dbtfy-quantity_breaks"><div class="card card-body-xs text-center qb-alert">`;

        const nextMostValuableQuantityBreakDiscount = quantityBreaksDiscounts.find((discount) => {
          const discountSavedAmount = getSavedMoney(discount, cart);
          const discountBreakCount = discount.breakCount;

          return discountSavedAmount > mostValuableDiscountSavedAmount && discountBreakCount > cartItemsCount && discountSavedAmount <= cartTotal;
        });

        if (nextMostValuableQuantityBreakDiscount) {
          const nextBreakDiscountCount = nextMostValuableQuantityBreakDiscount.breakCount - cartItemsCount;
          let nextBreakDiscountAmount = `${nextMostValuableQuantityBreakDiscount.amount}%`;

          if (nextMostValuableQuantityBreakDiscount.type === "$") {
            nextBreakDiscountAmount = `<span class="money">${theme.Currency.formatMoney(nextMostValuableQuantityBreakDiscount.amount * 100, moneyFormat)}</span>`;
          }

          if (moreDiscountBeforeQuantityText || moreDiscountAfterQuantityText || moreDiscountAfterPercentageText) {
            message += `<div class="qb-text">${moreDiscountBeforeQuantityText} <strong class="text-secondary">${nextBreakDiscountCount}</strong> ${moreDiscountAfterQuantityText} <strong class="text-secondary">${nextBreakDiscountAmount}</strong> ${moreDiscountAfterPercentageText}</div>`;
          }
        } else if (highestDiscountText && mostValuableDiscountSavedAmount > 0) {
          message += `<div class="qb-highest-discount-text">${highestDiscountText}</div>`;
        }

        message += "</div></div>";

        // Insert into cart drawer
        const existedDrawerAlert = document.querySelector(".qb-alert-drawer-wrapper");

        if (existedDrawerAlert) {
          existedDrawerAlert.remove();
        }

        if (ajaxCartSubtotal) {
          ajaxCartSubtotal.insertAdjacentHTML("afterend", message);

          const messageInDrawer = document.querySelector("#CartDrawer .dbtfy-quantity_breaks");

          if (messageInDrawer) {
            messageInDrawer.classList.add("qb-alert-drawer-wrapper", "spacer-top");
          }
        }

        // Insert on cart page
        const existedCartPageAlert = document.querySelector(".qb-alert-wrapper");

        if (existedCartPageAlert) {
          existedCartPageAlert.remove();
        }

        if (cartPageCartSubtotal) {
          cartPageCartSubtotal.insertAdjacentHTML("afterend", message);

          const messageInCartPage = document.querySelector("#cartForm .dbtfy-quantity_breaks");

          if (messageInCartPage) {
            messageInCartPage.classList.add("qb-alert-wrapper", "spacer-top-sm", "spacer-bottom");
          }
        }

        // Convert the quantity breaks amount on custom currency switcher
        var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
          shopCurrency = theme.strings.shopCurrency;

        if (currencySelector.length) {
          Currency.convertAll(shopCurrency, Currency.currentCurrency, ".qb-alert .money");
        }
      }

      function getSavedMoney(discount, cart) {
        let savedMoney = 0;

        if (discount) {
          switch (discount.type) {
            case "$":
              savedMoney = discount.amount * 100;

              break;

            case "%":
              savedMoney = cart.items_subtotal_price * (discount.amount / 100);

              break;
          }
        }

        return savedMoney;
      }

      document.addEventListener("dbtfy:upsellPopupLoaded", () => {
        if (theme.isCartLoaded) {
          breaksOnCartUpdate(theme.cart);
        } else {
          document.addEventListener("dbtfy:cartLoaded", () => {
            breaksOnCartUpdate(theme.cart);
          });
        }
      });

      $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
        breaksOnCartUpdate(cart);
      });

      // If cart page
      if (document.body.classList.contains("template-cart")) {
        if (theme.isCartLoaded) {
          breaksOnCartUpdate(theme.cart);
        } else {
          document.addEventListener("dbtfy:cartLoaded", () => {
            breaksOnCartUpdate(theme.cart);
          });
        }
      }
    }

    QuantityBreaks();}

  function themeQuantityBreaksDestroy() {document.body.classList.add("dbtfy-quantity_breaks-destroy");

    destroyQuantityBreaks();

    function destroyQuantityBreaks() {
      const quantityBreaks = document.querySelectorAll(".qb-wrapper");
      const productQuantities = document.querySelectorAll(".product-single__quantity");

      quantityBreaks.length && quantityBreaks.forEach((quantityBreak) => {
        quantityBreak.remove();
      });

      productQuantities.length && productQuantities.forEach((productQuantity) => {
        const isQuantityEnabled = productQuantity.hasAttribute("data-quantity-enabled");
        const isQuantityInventoryEnabled = productQuantity.hasAttribute("data-inventory-quantity-enabled");

        if (!isQuantityEnabled && !isQuantityInventoryEnabled) {
          productQuantity.remove();
        }
      });
    }}
  /* end-dbtfy-quantity-breaks */

  /* start-dbtfy-quick-view */
  function themeQuickView() {}

  function themeQuickViewDestroy() {}
  /* end-dbtfy-quick-view */

  /* start-dbtfy-recently-viewed */
  function themeRecentlyViewed() {function RecentlyViewed() {
      var dbtfy = $(".dbtfy-recently_viewed"),
        rvBox = ".rv-box",
        rvMain = ".rv-main",
        rvGrid = "rv-js-grid",
        rvProductdiv = ".rv-product-js",
        rvThumbnail = $(".rv-js-grid .rv-thumbnail"),
        rvTemplate = "recently-viewed",
        $body = $("body"),
        rvProductHandle,
        rvStorage,
        rvProducts,
        displayProducts,
        rvProductArray;

      if (!dbtfy.length) {
        return;
      }

      // If length of the product Handle
      if ($body.hasClass("template-product") && $(".product-single[data-product-handle]").length) {
        rvProductHandle = $(".product-single").data("product-handle").toString();
        rvStorage = localStorage.getItem("RecentlyViewed");
        rvProducts = getStorageProducts(rvStorage, rvProductHandle);
      } else if (dbtfy.length) {
        rvStorage = localStorage.getItem("RecentlyViewed");
        rvProducts = getStorageProducts(rvStorage, rvProductHandle);
      }

      if (rvProducts) {
        rvProductArray = unescape(rvProducts).split(",");
      }

      if (rvProductHandle) {
        // If current product handle in recently viewed list
        if(!$.inArray(rvProductHandle, rvProductArray) !== -1) {
          displayProducts = [];
          rvProductArray.unshift(rvProductHandle);

          $.each(rvProductArray, function(i, el) {
            if ($.inArray(el, displayProducts) === -1) {
              displayProducts.push(el);
            }
          });
        }

        setStorageProducts(displayProducts);
      } else {
        displayProducts = rvProductArray;
      }

      if (dbtfy.length) {
        getProductInformation(dbtfy, displayProducts, rvProductHandle);
      }

      // Get product handle from the localStorage
      function getStorageProducts(rvStorage, rvProductHandle) {
        if (!rvStorage && rvProductHandle) {
          localStorage.setItem("RecentlyViewed", rvProductHandle);
        }

        rvStorage = localStorage.getItem("RecentlyViewed");

        return rvStorage;
      }

      function setStorageProducts(rvProductArray) {
        localStorage.setItem("RecentlyViewed", escape(rvProductArray.join(",")));
      }

      function getProductInformation(parent, displayProducts, productHandle) {
        if (productHandle) {
          displayProducts.splice($.inArray(productHandle, displayProducts), 1);
        }

        var productLimit = parent.data("visible-products");

        if (productLimit && displayProducts) {
          displayProducts = displayProducts.slice(0, productLimit);
        }

        $.each(displayProducts, function (index, value) {
          if (value) {
            $.ajax({
              type: "GET",
              url: `/products/${value}?view=${rvTemplate}`,
              dataType: "html",
              success: function(data) {
                var rvProduct = $(data).find(rvProductdiv);

                parent.find(`${rvBox}-${index}`).append(rvProduct);
                parent.show();

                document.dispatchEvent(new CustomEvent("dbtfy:addedRecentlyViewedProduct"));
              },
              error: function(x, t, m) {
                console.log(x);
                console.log(t);
                console.log(m);
              }
            });
          }

          if (parent.find(rvMain).hasClass(rvGrid)) {
            if (displayProducts.length <= productLimit) {
              rvThumbnail.eq(displayProducts.length).nextAll().addBack().remove();
            } else {
              rvThumbnail.eq(productLimit).nextAll().addBack().remove();
            }
          }
        });
      }
    }

    RecentlyViewed();}

  function themeRecentlyViewedDestroy() {destroyRecentlyViewed();

    function destroyRecentlyViewed() {
      const recentlyViewedSections = document.querySelectorAll(".dbtfy-recently_viewed");

      recentlyViewedSections.length && recentlyViewedSections.forEach((recentlyView) => {
        recentlyView.remove();
      });
    }}
  /* end-dbtfy-recently-viewed */

  /* start-dbtfy-sales-countdown */
  function themeSalesCountdown() {function SalesCountdown() {
        const templatesContainer = document.querySelector(".dbtfy-sales-countdown-templates");

        if (!templatesContainer) {
          return;
        }

        const listCountdownTemplates = templatesContainer.querySelectorAll(".dbtfy-sales_countdown");
        const listProductCard = document.querySelectorAll(".grid-product");
        const listProductMainSections = document.querySelectorAll(".featured-product-section, .product-section");
        const textDays = templatesContainer.dataset.textDays;
        const textHours = templatesContainer.dataset.textHours;
        const textMinutes = templatesContainer.dataset.textMinutes;
        const textSeconds = templatesContainer.dataset.textSeconds;

        const sortedCountdownTemplates = new Map();

        sortedCountdownTemplates.set("all", []);
        sortedCountdownTemplates.set("collection", []);
        sortedCountdownTemplates.set("product", []);
        sortedCountdownTemplates.set("type", []);
        sortedCountdownTemplates.set("tag", []);

        listCountdownTemplates.forEach((template) => {
          const templateType = template.dataset.visibility;

          if (sortedCountdownTemplates.has(templateType)) {
            const currentCountdownTemplates = sortedCountdownTemplates.get(templateType);

            currentCountdownTemplates.push(template);
            sortedCountdownTemplates.set(templateType, currentCountdownTemplates);
          }
        });

        for (let [type, templates] of sortedCountdownTemplates) {
          templates.forEach((template) => {
            const templateOptions = {
              action: template.dataset.action,
              visibility: template.dataset.visibility,
              showInProductGrid: template.dataset.showInProductGrid,
              tags: template.dataset.tag,
              types: template.dataset.type,
              productId: template.dataset.product,
              collection: template.dataset.collection,
              template: template.cloneNode(true),
              countdownId: template.dataset.countdownId,
              dataDate: template.dataset.date,
              timeHours: template.dataset.hours,
              timeMins: template.dataset.minutes,
              timeSeconds: "59"
            }

            listProductMainSections.forEach((section) => {
              const productJSON = section.querySelector(".mainProductJson");

              if (!productJSON) {
                return;
              }

              const sectionProductJson = JSON.parse(productJSON.innerHTML);

              checkProductEqual(sectionProductJson, section, templateOptions);
            });

            if (templateOptions.showInProductGrid === "true") {
              listProductCard.forEach((card) => {
                const cardProductJson = JSON.parse(card.querySelector(".productCardJson").innerHTML);

                checkProductEqual(cardProductJson, card, templateOptions);
              });
            }

            initializeClock(templateOptions);
          })
        }

        // After adding templates to products and initializing timers, delete the section with templates.
        templatesContainer.remove();

        function checkProductEqual(productJson, card, templateOptions) {
          if (productJson.price < productJson.compare_at_price) {
            const productCollections = productJson.collections;
            const equalToCollection = productCollections.length && productCollections.includes(templateOptions.collection);

            const productTags = productJson.tags.map(tag => tag.toLowerCase());
            const templateDataTagsArr = templateOptions.tags.split(',').filter(tag => tag).map(tag => tag.trim().toLowerCase());
            const isFound = productTags.some(tag => templateDataTagsArr.includes(tag));

            const productType = productJson.type.toLowerCase();
            const templateDataTypesArr = templateOptions.types.split(",").filter(type => type).map(tag => tag.trim().toLowerCase());

            if (templateOptions.visibility === "all") {
              addTemplate(card, templateOptions, productJson);
            } else {
              if (templateOptions.visibility === "product" && productJson.id === +templateOptions.productId) {
                addTemplate(card, templateOptions, productJson);
              } else if (templateOptions.visibility === "collection" && equalToCollection) {
                addTemplate(card, templateOptions, productJson);
              } else if (templateOptions.visibility === "tag" && isFound) {
                addTemplate(card, templateOptions, productJson);
              } else if (templateOptions.visibility === "type" && templateDataTypesArr.includes(productType)) {
                addTemplate(card, templateOptions, productJson);
              }
            }
          }
        }

        function addTemplate(card, templateOptions, productJson) {
          const cloneTemplate = templateOptions.template;
          const productVariantComparePrice = +productJson.first_available_variant_compare_at_price;

          cloneTemplate.hidden = productJson.price > productVariantComparePrice;

          card.querySelectorAll(".dbtfy-sales_countdown").forEach(timer => timer.remove());

          if (card.classList.contains("grid-product"))  {
            if (templateOptions.showInProductGrid) {
              cloneTemplate.classList.add("text-small");
            }

            card.querySelector(".grid-product__price-wrap").insertAdjacentHTML("afterend", cloneTemplate.outerHTML);
          } else {
            card.querySelectorAll(".dbtfy-product-sales-countdown-box").forEach(item => {
              cloneTemplate.classList.remove("spacer-bottom-sm");

              if (item.classList.contains("main-product-block")) {
                cloneTemplate.classList.add("spacer-bottom-sm");
              }

              item.insertAdjacentHTML("beforeend", cloneTemplate.outerHTML);
            });
          }
        }

        function initializeClock(options) {
          const listTimers = document.querySelectorAll(".dbtfy-sales_countdown");
          const listTimersArray = Array.from(listTimers).filter((timer) => timer.dataset.countdownId === options.countdownId);

          let $days = Array.from(document.querySelectorAll(".days-sales_countdown")).filter(day => day.closest(`.${options.countdownId}`));
          let $hours = Array.from(document.querySelectorAll(".hours-sales_countdown")).filter(hour => hour.closest(`.${options.countdownId}`));
          let $minutes = Array.from(document.querySelectorAll(".minutes-sales_countdown")).filter(minute => minute.closest(`.${options.countdownId}`));
          let $seconds = Array.from(document.querySelectorAll(".seconds-sales_countdown")).filter(second => second.closest(`.${options.countdownId}`));
          let endtime = "";
          let countDownDate = "";

          setDate();

          function setDate() {
            if (options.dataDate !== "" && options.action !== "reload") {
              endtime = `${options.dataDate} ${options.timeHours}:${options.timeMins}:${options.timeSeconds}`;
            } else {
              if (sessionStorage.hasOwnProperty(options.countdownId)) {
                endtime = sessionStorage.getItem(options.countdownId);
              } else {
                const startDate = new Date();
                const time = startDate.getTime();
                const newTime = time + (1000 * 60 * 60 * options.timeHours) + (1000 * 60 * options.timeMins);
                endtime = new Date(newTime);
              }
            }

            if (options.dataDate === "" || options.action === "reload") {
              // Store endtime in session
              sessionStorage.setItem(options.countdownId, endtime);
            }

            // Set the date were counting down to
            countDownDate = new Date(endtime).getTime();
          }

          let x = setInterval(salesTimer, 1000);

          // Update the count down every 1 second
          function salesTimer() {
            // Get today's date and time
            const now = new Date().getTime();

            // Find the distance between now and the count down date
            const distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display days
            if (days <= 0) {
              $days.forEach((day) => {
                day.hidden = true;
              });
            } else {
              $days.forEach((day) => {
                day.textContent = days + textDays;
              })
            }

            // Display hours
            if (days <= 0 && hours <= 0) {
              $hours.forEach((hour) => {
                hour.hidden = true;
              });
            } else {
              $hours.forEach((hour) => {
                hour.textContent = hours + textHours;
              });
            }

            // Display minutes
            if (days <= 0 && hours <= 0 && minutes <= 0) {
              $minutes.forEach((minute) => {
                minute.hidden = true;
              });
            } else {
              $minutes.forEach((minute) => {
                minute.textContent = minutes + textMinutes;
              });
            }

            // Display seconds
            $seconds.forEach((second) => {
              second.textContent = seconds + textSeconds;
            });

            // If the count down is finished
            if (distance < 0) {
              clearInterval(x);

              if (options.action === "reload") {
                sessionStorage.removeItem(options.countdownId);
                setDate();
                x = setInterval(salesTimer, 1000);
                salesTimer();
              } else if (options.action === "message") {
                listTimersArray.forEach(timer => {
                  let timerMessage = timer.querySelector(".dbtfy-sales_countdown_message");

                  if (timerMessage) {
                    timerMessage.hidden = false;
                    timer.querySelector(".SalesCountdown").hidden = true;
                  } else {
                    timer.hidden = true;
                  }
                });
              } else {
                listTimersArray.forEach((timer) => {
                  timer.hidden = true;
                });
              }
            }
          }

          // Init timer
          salesTimer();

          document.addEventListener("variantChanged", salesTimer);
        }

        var productOptions = document.querySelectorAll(".single-option-selector__radio");
        var productJson = [];

        productOptions.forEach((productOption) => {
          const section = productOption.closest("div[data-section-type='product-template']");
          const sectionId = section.dataset.sectionId;
          const productJSONElement = section.querySelector(`#ProductJson-${sectionId}`);

          if (productJSONElement) {
            productJson[sectionId] = JSON.parse(productJSONElement.innerHTML);

            productOption.addEventListener("change", () => {
              let variantPrice = 0;
              let variantComparePrice = 0;
              let productSelect = section.querySelector("[id^='MainProductSelect']");
              let selectedVariant = null;
              let isAvailable = false;
              let selectedVariantId = +productSelect.value;
              let variants = productJson[sectionId] ? productJson[sectionId].variants : [];

              variants.forEach((variant) => {
                if (selectedVariantId === variant.id) {
                  selectedVariant = variant;
                  variantPrice = variant.price;
                  variantComparePrice = variant.compare_at_price;
                  isAvailable = variant.available;
                }
              });

              const salesCountdown = section.querySelector(".dbtfy-sales_countdown");

              if (!salesCountdown) {
                return;
              }

              if (!variantComparePrice || !isAvailable) {
                salesCountdown.setAttribute("hidden", "hidden");
              } else {
                salesCountdown.removeAttribute("hidden");
              }

              document.dispatchEvent(new CustomEvent("variantChanged"));
            });
          }
        });
      }

      document.addEventListener("shopify:section:select", (event) => {
        for (const key in sessionStorage) {
          if (key.includes("dbtfy-countdown")) {
            sessionStorage.removeItem(key);
          }
        }
      });

      SalesCountdown();}

  function themeSalesCountdownDestroy() {destroySalesCountdown();

    $(document).on("shopify:section:load", function() {
      destroySalesCountdown();
    });

    function destroySalesCountdown() {
      const salesCountdowns = document.querySelectorAll(".dbtfy-sales_countdown");

      salesCountdowns.length && salesCountdowns.forEach((salesCountdown) => {
        salesCountdown.remove();
      });
    }}
  /* end-dbtfy-sales-countdown */

  /* start-dbtfy-sales-pop */
  function themeSalesPop() {function SalesPop() {
      var dbtfy = $(".dbtfy-sales_pop");

      if (!dbtfy.length) {
        return;
      }

      var names = dbtfy.data("name").split(","),
        cities = dbtfy.data("cities").split(","),
        minute = dbtfy.data("minute"),
        minutes = dbtfy.data("minutes"),
        hour = dbtfy.data("hour"),
        hours = dbtfy.data("hours"),
        day = dbtfy.data("day"),
        days = dbtfy.data("days"),
        displayTime = dbtfy.data("display-time"),
        intervalTime = dbtfy.data("interval-time"),
        timeAgo = dbtfy.data("time-ago"),
        animTime = 1000,
        totalTime = intervalTime + displayTime + animTime,
        $salespop = $("#SalesPop"),
        $salespopItemWrapper = $(".item-wrapper-sales_pop"),
        $salespopClose = $(".btn-close-sales_pop"),
        $salespopTime = $(".time-sales_pop"),
        $salespopName = $(".name-sales_pop"),
        $salespopCity = $(".city-sales_pop"),
        openClass = "sp-open",
        salespopInterval;

      $.fn.shuffleChildren = function() {
        $.each(this.get(), function(index, el) {
          var $el = $(el);
          var $find = $el.children();

          $find.sort(function() {
            return 0.5 - Math.random();
          });

          $el.empty();
          $find.appendTo($el);
        });
      };

      function randomName() {
        var randomItemName = names[Math.floor(Math.random() * names.length)];
        $salespopName.text(randomItemName);
      }

      function randomCity() {
        var randomItemCity = cities[Math.floor(Math.random() * cities.length)];
        $salespopCity.text(randomItemCity);
      }

      function randomTime() {
        var randomlytimeAgo = Math.floor(Math.random() * timeAgo);

        if (randomlytimeAgo <= 1) {
          var timeStamp = minute;
          var randomlytimeAgo = 1;
        } else if (randomlytimeAgo < 60) {
          var timeStamp = minutes;
        } else if (randomlytimeAgo < 120) {
          randomlytimeAgo = Math.floor(randomlytimeAgo / 60);
          var timeStamp = hour;
        } else if (randomlytimeAgo < 1440) {
          randomlytimeAgo = Math.floor(randomlytimeAgo / 60);
          var timeStamp = hours;
        } else if (randomlytimeAgo < 2880) {
          randomlytimeAgo = Math.floor(randomlytimeAgo / 60 / 24);
          var timeStamp = day;
        } else {
          randomlytimeAgo = Math.floor(randomlytimeAgo / 60 / 24);
          var timeStamp = days;
        }

        $salespopTime.text(randomlytimeAgo + timeStamp);
      }

      function openSalespop() {
        $salespop.addClass(openClass);
      }

      function closeSalespop() {
        theme.closeTransition({
            elementToTransition: $salespop
          },
          function() {
            $(".item-wrapper-sales_pop > .item-sales_pop:first").appendTo(".item-wrapper-sales_pop");
          });

        $salespop.removeClass(openClass);
      }

      function animPop() {
        if (!sessionStorage.popClosed) {
          randomName();
          randomCity();
          randomTime();
          openSalespop();

          setTimeout(function() {
            // Don't close if already closed by close button
            if (!$salespop.hasClass(openClass)) {
              return;
            }

            closeSalespop();
          }, displayTime);
        }
      }

      function destroySalespop() {
        sessionStorage.setItem("popClosed", "true");
        clearInterval(salespopInterval);
        closeSalespop();
      }

      $salespopItemWrapper.shuffleChildren();

      setTimeout(function() {
        animPop();
        salespopInterval = setInterval(animPop, totalTime);
      }, intervalTime);

      $salespopClose.click(function() {
        destroySalespop();
      });
    }

    $(document).on("shopify:section:load", function() {
      sessionStorage.removeItem("popClosed");
    });

    SalesPop();}

  function themeSalesPopDestroy() {document.body.classList.add("dbtfy-sales_pop-destroy");

    destroySalesPop();

    $(document).on("shopify:section:load", function() {
      destroySalesPop();
    });

    function destroySalesPop() {
      const salesPopups = document.querySelectorAll(".dbtfy-sales_pop");

      salesPopups.length && salesPopups.forEach((salesPopup) => {
        salesPopup.remove();
      });
    }}
  /* end-dbtfy-sales-pop */

  /* start-dbtfy-shop-protect */
  function themeShopProtect() {function ShopProtect() {
      var isProtectImage = theme.settings.dbtfyShopProtectImage;
      var isProtectDrag = theme.settings.dbtfyShopProtectDrag;
      var isProtectProductText = theme.settings.dbtfyShopProtectTextProduct;
      var isProtectArticleText = theme.settings.dbtfyShopProtectTextArticle;
      var isProtectCollection = theme.settings.dbtfyShopProtectCollection;

      function protectImage() {
        if (isProtectImage) {
          $("img").on("contextmenu", function(e) {
            return false;
          });
        }
      }

      function protectDrag() {
        if (isProtectDrag) {
          $("img").mousedown(function(e) {
            e.preventDefault();
          });
        }
      }

      function protectProductText() {
        if (isProtectProductText) {
          $(".product-single__description, .qv-description, .tab-content").addClass("dbtfy-shop_protect-text");
        }
      }

      function protectArticleText() {
        if (isProtectArticleText) {
          $(".article-section, .blog-section").addClass("dbtfy-shop_protect-text");
        }
      }

      function protectCollection() {
        if (isProtectCollection) {
          $("#sortBy option[value='best-selling']").remove();

          var collectionSort = window.location.search;

          if (collectionSort === "?sort_by=best-selling") {
            window.location.replace("/collections");
          }
        }
      }

      setTimeout(function() {
        protectImage();
        protectDrag();
      }, 1000);

      protectProductText();
      protectArticleText();
      protectCollection();

      $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
        protectImage();
        protectDrag();
      });
    }

    ShopProtect();

    document.addEventListener("QuickViewLoaded", () => {
      ShopProtect();
    });

    document.addEventListener("dbtfy:addedRecentlyViewedProduct", () => {
      ShopProtect();
    });}
  /* end-dbtfy-shop-protect */

  /* start-dbtfy-size-chart */
  function themeSizeChart() {function SizeChart() {
      const dbtfy = $(".dbtfy-size_chart");

      if (!dbtfy.length) {
        return;
      }

      const scLink = $(".sc-link");
      const scProductForm = $(".product-single__meta form.product-single__form");

      function moveSizeChart() {
        scProductForm.prepend(scLink);
      }

      moveSizeChart();

      $(document).on("shopify:section:load", function() {
        moveSizeChart();
      });
    }

    SizeChart();}

  function themeSizeChartDestroy() {destroySizeChart();

    function destroySizeChart() {
      const sizeCharts = document.querySelectorAll(".dbtfy-size_chart");

      sizeCharts.length && sizeCharts.forEach((sizeChart) => {
        sizeChart.remove();
      });
    }}
  /* end--dbtfy-size-chart */

  /* start-dbtfy-smart-search */
  function themeSmartSearch() {function SmartSearch() {
      var dbtfy = $(".dbtfy-smart_search");

      if (!dbtfy.length) {
        return;
      }

      var dataPrice = dbtfy.data("price");
      var dataVendor = dbtfy.data("vendor");
      var dataOnlyProduct = dbtfy.data("only-product");
      var dataImagePlaceholder = $(".ss-image-placeholder").html();

      var searchDrawer = $("#SearchDrawer"),
        form = $("#SearchDrawer form[action='/search']"),
        input = form.find("input[name='q']"),
        loading = $(".ss-loading"),
        resultSections = $(".ss-section"),
        resultWrapper = $(".ss-section-wrapper"),
        searchInput = $("#SearchDrawer .search-input"),
        typingTimer,
        doneTypingInterval = 500;

      if(dataOnlyProduct) {
        var searchHref = "/search?type=product&";
      } else {
        var searchHref = "/search?";
      };

      // On key up, start the countdown
      searchInput.attr("autocomplete", "off").keyup(function(evt) {
        var $this = $(this),
          TAB_KEY_CODE = 9,
          SHIFT_KEY_CODE = 16,
          RETURN_KEY_CODE = 13,
          UP_ARROW_KEY_CODE = 38,
          DOWN_ARROW_KEY_CODE = 40,
          RIGHT_ARROW_KEY_CODE = 39,
          LEFT_ARROW_KEY_CODE = 37,
          ESCAPE_KEY_CODE = 27,
          CONTROL_KEY_CODE = 17,
          term = $this.val(),
          form = $this.closest("form"),
          searchURL = `${searchHref}q=${term}&options[prefix]=last`,
          resultLimit = dbtfy.data("limit");

        if (evt.which === LEFT_ARROW_KEY_CODE || evt.which === RIGHT_ARROW_KEY_CODE || evt.which === UP_ARROW_KEY_CODE || evt.which === DOWN_ARROW_KEY_CODE || evt.which === RETURN_KEY_CODE || evt.which === CONTROL_KEY_CODE || evt.which === TAB_KEY_CODE || evt.which === SHIFT_KEY_CODE) {
          evt.preventDefault();

          return false;
        }

        loading.show();
        resultWrapper.hide();

        clearTimeout(typingTimer);

        if (term) {
          typingTimer = setTimeout(runSearch, doneTypingInterval);
        } else {
          loading.hide();
          resultWrapper.hide();

          return false;
        }

        function runSearch() {
          jQuery.getJSON("/search/suggest.json", {
            "q": term,
            "resources": {
              "type": "product,article,page,collection",
              "limit": resultLimit,
              "options": {
                "unavailable_products": "last",
                "fields": "title"
              }
            }
          }).done(function(response) {
            var products = response.resources.results.products;
            var posts = response.resources.results.articles;
            var pages = response.resources.results.pages;
            var collections = response.resources.results.collections;

            // Products
            if (products.length === 0) {
              $(".ss-products").hide();
            } else {
              $(".ss-products").find(".ss-content").empty();

              $.each(products, function(index, item) {
                jQuery.getJSON("/products/" + item.handle, function(data) {
                  var moneyFormat = theme.strings.moneyFormat;
                  var compare_price = data.product.variants[0].compare_at_price;
                  var price = data.product.variants[0].price;
                  var info = $("<a></a>").attr("href", `/products/${data.product.handle}`);
                  var item_info = `<span class="ss-info"><span class="ss-title h6">${data.product.title}</span>`;

                  if (data.product.image && data.product.image.src) {
                    var resultImage = data.product.image.src.replace(/(\.[^.]*)$/, "_100x$1").replace("http:", "");
                    info.append(`<span class="ss-thumbnail"><img src="${resultImage}" /></span>`);
                  } else {
                    info.append(`<span class="ss-thumbnail">${dataImagePlaceholder}</span>`);
                  }

                  if (dataPrice) {
                    if (compare_price > price) {
                      item_info += `<span class="ss-price-container price-compare text-small text-money"><span class="text-sale"><span class="money">${theme.Currency.formatMoney(price, moneyFormat)}</span></span> <span class="ss-price text-strike text-muted"><span class="money">${theme.Currency.formatMoney(compare_price, moneyFormat)}</span></span></span>`;
                    } else {
                      item_info += `<span class="ss-price-container ss-price text-small text-money"><span class="money">${theme.Currency.formatMoney(price, moneyFormat)}</span></span>`;
                    }
                  }

                  if (dataVendor) {
                    item_info += `<span class="ss-vendor text-small text-muted text-italic">${data.product.vendor}</span>`;
                  }

                  item_info += "</span>";
                  info.append(item_info);
                  info.wrap("<div class='ss-item'></div>");

                  $(".ss-products").find(".ss-content").append(info.parent());

                  // Convert the product price on custom currency switcher
                  var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
                    shopCurrency = theme.strings.shopCurrency;

                  if (currencySelector.length) {
                    Currency.convertAll(shopCurrency, Currency.currentCurrency);
                  }
                });
              });

              $(".ss-products").show();
            }

            // posts
            if (posts.length === 0) {
              $(".ss-posts").hide();
            } else {
              $(".ss-posts").find(".ss-content").empty();

              $.each(posts, function(index, item) {
                var info = $("<a></a>").attr("href", item.url);

                if (item.image) {
                  var resultImage = item.image.replace(/(\.[^.]*)$/, "_100x$1").replace("http:", "");

                  info.append(`<span class="ss-thumbnail"><img src="${resultImage}" /></span>`);
                }

                info.append(`<span class="ss-info"><span class="ss-title">${item.title}</span></span>`);
                info.wrap("<div class='ss-item'></div>");

                $(".ss-posts").find(".ss-content").append(info.parent());
              });

              $(".ss-posts").show();
            }

            // Pages
            if (pages.length === 0) {
              $(".ss-pages").hide();
            } else {
              $(".ss-pages").find(".ss-content").empty();

              $.each(pages, function(index, item) {
                var info = $("<a></a>").attr("href", item.url);

                info.append(`<span class="ss-info"><span class="ss-title">${item.title}</span></span>`);
                info.wrap("<div class='ss-item'></div>");

                $(".ss-pages").find(".ss-content").append(info.parent());
              });

              $(".ss-pages").show();
            }

            // Collections
            if (collections.length === 0) {
              $(".ss-collections").hide();
            } else {
              $(".ss-collections").find(".ss-content").empty();

              $.each(collections, function(index, item) {
                var info = $("<a></a>").attr("href", item.url);

                if (item.featured_image.url) {
                  var resultImage = item.featured_image.url.replace(/(\.[^.]*)$/, "_100x$1").replace("http:", "");

                  info.append(`<span class="ss-thumbnail"><img src="${resultImage}" /></span>`);
                }

                info.append(`<span class="ss-info"><span class="ss-title">${item.title}</span></span>`);
                info.wrap("<div class='ss-item'></div>");

                $(".ss-collections").find(".ss-content").append(info.parent());
              });

              $(".ss-collections").show();
            }

            // Show all
            $(".ss-showall").find("a").attr("href", searchURL);
            $(".ss-showall").find("span").text(term);
          }).always(function() {
            setTimeout(function() {
              loading.hide();
              resultWrapper.show();

              // Trap focus again for new search result item added
              theme.trapFocus({
                $container: searchDrawer
              });
            }, 1000);
          });
        }
      });

      searchInput.on("keydown", function(e) {
        var RETURN_KEY_CODE = 13;
        var UP_ARROW_KEY_CODE = 38;
        var DOWN_ARROW_KEY_CODE = 40;
        var ESCAPE_KEY_CODE = 27;

        if (e.keyCode === UP_ARROW_KEY_CODE || e.keyCode === DOWN_ARROW_KEY_CODE || e.keyCode === RETURN_KEY_CODE) {
          e.preventDefault();
        }

        if (e.which === DOWN_ARROW_KEY_CODE) {
          if ($(".item-selected").length > 0) {
            if ($(".item-selected").next().length != 0) {
              var focused = $(".item-selected");

              $(".item-selected").removeClass("item-selected");
              focused.next().addClass("item-selected");
            }
          } else {
            $(".ss-item").eq(0).addClass("item-selected");
          }
        } else if (e.which === UP_ARROW_KEY_CODE) {
          if ($(".item-selected").length > 0) {
            if ($(".item-selected").prev().length != 0) {
              var focused = $(".item-selected");

              $(".item-selected").removeClass("item-selected");
              focused.prev().addClass("item-selected");
            }
          } else {
            $(".ss-item").eq(0).addClass("item-selected");
          }
        }

        if (e.which === RETURN_KEY_CODE) {
          if ($(".item-selected a").length) {
            window.location.href = $(".item-selected a").attr("href");
          } else {
            $(e.target).closest("form").submit();
          }
        }
        if (e.which === ESCAPE_KEY_CODE) {
          this.close();
        }
      });

      // Clear search results by clicking clear icon
      searchInput.on("search", function() {
        resultWrapper.hide();
      });
    }

    SmartSearch();}

  function themeSmartSearchDestroy() {destroySmartSearch();

    function destroySmartSearch() {
      const smartSearches = document.querySelectorAll(".dbtfy-smart_search");

      smartSearches.length && smartSearches.forEach((smartSearch) => {
        smartSearch.remove();
      });
    }}
  /* end-dbtfy-smart-search */

  /* start-dbtfy-social-discount */
  function themeSocialDiscount() {}

  function themeSocialDiscountDestroy() {}
  /* end-dbtfy-social-discount */

  /* start-dbtfy-sticky-addtocart */
  function themeStickyAddtocart() {async function StickyAddtocart() {
      let stickyATC = document.querySelector(".dbtfy-sticky_addtocart");

      if (!stickyATC) {
        return;
      }

      const listVariantSelects = document.querySelectorAll(".single-option-selector__radio");
      const masterSelect = document.querySelector("[id^='MainProductSelect']");
      const productTemplateMetaContainer = document.querySelector("#ProductMeta-product-template");
      let cart = await ShopifyAPI.getCart();
      let dataPosition = stickyATC.dataset.position;
      let stickyImages = stickyATC.querySelectorAll(".image-sticky_addtocart");
      let addtocartButton = document.querySelector(".product-single__add-to-cart .btn--add-to-cart");
      let stickyAddtocart = stickyATC.querySelector("#stickyAddToCart");
      let stickyATCButton = stickyATC.querySelector(".btn--sticky_addtocart");
      let stickyATCButtonText = stickyATCButton.querySelector(".btn-text-sticky_addtocart");
      let targetScroll = addtocartButton.offsetTop + addtocartButton.offsetHeight;
      let moneyFormat = theme.strings.moneyFormat;
      let animTime = theme.variables.animationDuration;
      let scrollClass = dataPosition === "top" ? null: "scroll-sticky_addtocart";
      let visibleClass = "sa-visible";
      let hasReachedScroll = false;
      let qtBox = document.querySelector(".quantity-sticky_addtocart");
      let variantStickyProduct = stickyATC.querySelector(".select-sticky_addtocart");
      let qtyField = qtBox.querySelector("input");

      // Scroll event
      window.addEventListener("scroll", () => {
        if (window.pageYOffset > targetScroll) {
          stickyAddtocart.classList.add(visibleClass);
          scrollClass && document.body.classList.add(scrollClass);
          hasReachedScroll = true;
        } else {
          if (hasReachedScroll) {
            hasReachedScroll = false;

            theme.closeTransition({
              elementToTransition: stickyAddtocart,
              animationSpeed: animTime
            }, function () {
              stickyAddtocart.classList.remove(visibleClass);
              scrollClass && document.body.classList.remove(scrollClass);
            });
          }
        }
      });

      function calculateDiscountPrice(totalPrice, totalComparePrice, variant) {
        let discount = null;

        if (variant === "percentage") {
          let discountValue = Math.floor(((totalComparePrice - totalPrice) * 100) / totalComparePrice);
          discount = `${discountValue}%`;
        } else {
          let discountValue = totalComparePrice - totalPrice;
          discount = theme.Currency.formatMoney(discountValue, moneyFormat);
        }

        return discount;
      }

      function checkPrice() {
        let priceBox = stickyATC.querySelector(".total-sticky-price");
        let comparePriceBox = stickyATC.querySelector(".total-sticky-compare-price");
        let stickyDiscountBox = stickyATC.querySelector(".discount-sticky-price");
        let stickyDiscountBoxText = stickyATC.querySelector(".discount-sticky-price-text");
        let selectedVariant = variantStickyProduct.options[variantStickyProduct.selectedIndex];

        if (!selectedVariant) {
          return;
        }

        let variantPrice = +selectedVariant.dataset.price;
        let variantCompareAtPrice = +selectedVariant.dataset.compareAtPrice;
        let discountSaved = Boolean(stickyATC.querySelector(".dbtfy-sticky-price-box").dataset.discountSaved);

        priceBox.innerHTML = `<span class="money">${theme.Currency.formatMoney(variantPrice, moneyFormat)}</span>`;

        if (variantPrice < variantCompareAtPrice) {
          comparePriceBox.innerHTML = `<span class="money">${theme.Currency.formatMoney(variantCompareAtPrice, moneyFormat)}</span>`;
          comparePriceBox.style.display = "inline-block";
          priceBox.classList.add("text-sale");

          if (stickyDiscountBox && discountSaved) {
            let discountVariant = stickyDiscountBox.dataset.discountVariant;
            let discountValue = calculateDiscountPrice(variantPrice, variantCompareAtPrice, discountVariant);

            const valueStr = (discountVariant === "percentage") ? discountValue : `<span class="money">${discountValue}</span>`;

            stickyDiscountBoxText.innerHTML = theme.strings.saveFormat.replace(/\{\{ saved_amount \}\}/, valueStr);
            stickyDiscountBox.style.display = "inline-block";
          }
        } else {
          comparePriceBox.style.display = "none";
          priceBox.classList.remove("text-sale");

          if (stickyDiscountBox) {
            stickyDiscountBox.style.display = "none";
          }
        }

        // Convert the product price on select change based on selected currency
        var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
          shopCurrency = theme.strings.shopCurrency;

        if (currencySelector.length && shopCurrency && Currency.currentCurrency) {
          Currency.convertAll(shopCurrency, Currency.currentCurrency);
        }
      }

      function setMaxQuantity() {
        if (variantStickyProduct) {
          const currentVariant = variantStickyProduct.selectedOptions[0];
          const currentVariantInventory = currentVariant.hasAttribute("data-remain-qty") ? +currentVariant.dataset.remainQty : +currentVariant.dataset.productQty;

          if (currentVariantInventory > 0) {
            qtyField.setAttribute("max", currentVariantInventory);
          } else {
            qtyField.removeAttribute("max");
          }
        }
      }

      function checkQuantity() {
        const currentVariant = variantStickyProduct.selectedOptions[0];

        if (!currentVariant) {
          return;
        }

        const variantQty = currentVariant.hasAttribute("data-remain-qty") ? +currentVariant.dataset.remainQty : +currentVariant.dataset.productQty;
        const currentValue = +qtyField.value;
        const qtPlusButton = qtBox.querySelector(".qty-plus");

        if (variantQty > 0) {
          if (currentValue >= variantQty) {
            qtPlusButton.setAttribute("disabled", "disabled");
            qtyField.value = variantQty;
          } else {
            qtPlusButton.removeAttribute("disabled");
          }
        } else {
          qtyField.value = 1;
          qtPlusButton.setAttribute("disabled", "disabled");
        }

        if (currentValue === 0 && variantQty > 0) {
          qtyField.value = 1;

          if (variantQty === 1) {
            qtPlusButton.setAttribute("disabled", "disabled");
          }
        }
      }

      function setVariantQuantities(cart) {
        const options = variantStickyProduct.querySelectorAll("option");

        options.length && options.forEach((option) => {
          const currentVariantQuantity = option.getAttribute("data-product-qty");

          option.setAttribute("data-remain-qty", currentVariantQuantity);
        });

        cart && cart.items.forEach((item) => {
          const itemId = item.id;
          const itemQuantity = item.quantity;
          const variantOption = variantStickyProduct.querySelector(`option[value='${itemId}']`);

          if (variantOption) {
            const currentVariantQuantity = +variantOption.getAttribute("data-product-qty");

            variantOption.setAttribute("data-remain-qty", currentVariantQuantity - itemQuantity);
          }
        });
      }

      function setATCButtonState() {
        const currentVariant = variantStickyProduct.selectedOptions[0];

        if (!currentVariant) {
          return
        }

        const variantQty = currentVariant.hasAttribute("data-remain-qty") ? +currentVariant.dataset.remainQty : +currentVariant.dataset.productQty;

        if (variantQty > 0) {
          stickyATCButton.removeAttribute("disabled");
          stickyATCButtonText.innerHTML = theme.strings.addToCart;
        } else {
          stickyATCButton.setAttribute("disabled", "disabled");
          stickyATCButtonText.innerHTML = theme.strings.soldOut;
        }

        document.dispatchEvent(new CustomEvent("stickyATCButtonStateChanged"));
      }

      setVariantQuantities(cart);
      checkQuantity();
      checkPrice();
      setATCButtonState();

      if (qtBox) {
        qtBox.querySelectorAll("button").forEach(button => {
          button.addEventListener("click", (event) => {
            checkQuantity();
          })
        });
      }

      // Variant change
      if (variantStickyProduct) {
        variantStickyProduct.addEventListener("change", async (event) => {
          let currentSelect = event.target;
          let selectCurrentValue = currentSelect.value;
          let currentVariantPrice = currentSelect.options[currentSelect.selectedIndex].dataset.price;
          const singleProductBox = document.querySelector(".product-single");
          const pickerType = document.querySelector("#section-product-template").dataset.pickerType;
          const currentSelectedOption = currentSelect.selectedOptions[0];
          const variantOptionsSize = currentSelectedOption.dataset.optionSize;
          const swatchesIsPresent = !!document.querySelector(".dbtfy-color_swatches");

          changeStickyPanelVariantImage(selectCurrentValue);
          setMaxQuantity();
          checkQuantity();
          setATCButtonState();

          stickyATC.querySelector(".total-sticky-price").innerHTML = `<span class="money">${theme.Currency.formatMoney(currentVariantPrice, moneyFormat)}</span>`;

          checkPrice();

          let currencySelector = document.querySelector("#currency-list-header[name='dbtfy-custom-currencies']"),
            shopCurrency = theme.strings.shopCurrency;

          if (currencySelector) {
            Currency.convertAll(shopCurrency, Currency.currentCurrency, ".dbtfy-sticky-price-box .money");
          }

          for (let i = 1; i <= variantOptionsSize; i++) {
            const currentVariantOptionName = currentSelectedOption.dataset[`option-${i}`];
            const swatchesOption = singleProductBox.querySelector(`.input-color_swatches[value="${currentVariantOptionName}"]`);

            if (pickerType === "radio") {
              const fieldsetOptions = document.querySelector(`#ProductSelect-option-${i - 1}`);

              fieldsetOptions.querySelector(`.single-option-selector__radio[value="${currentVariantOptionName}"]`).click();
            } else {
              const productVariantSelect = document.querySelector(`#SingleOptionSelector-${i - 1}`);

              productVariantSelect.value = currentVariantOptionName;
              productVariantSelect.dispatchEvent(new Event("change"));
            }

            if (swatchesIsPresent && swatchesOption) {
              let swatchBox = swatchesOption.closest(".custom_swatch_elements");
              let swatchOptionLabel = swatchBox.querySelector(".single-option-radio__label");
              let labelTitle = swatchOptionLabel.dataset.label;

              swatchOptionLabel.innerHTML = `${labelTitle}: <span class="variant-label-option-value">${swatchesOption.value}</span>`;

              swatchesOption.checked = true;
            }
          }
        });
      }

      listVariantSelects.forEach((select) => select.addEventListener("change", (event) => {
        let stickyPanelHasVariant = variantStickyProduct.querySelector(`option[value="${masterSelect.value}"]`);

        if (!productTemplateMetaContainer.classList.contains("variant-unavailable") && stickyPanelHasVariant) {
          variantStickyProduct.value = masterSelect.value;
          changeStickyPanelVariantImage(variantStickyProduct.value);
          setATCButtonState();
          checkPrice();
        }
      }));

      function changeStickyPanelVariantImage(currentValue) {
        stickyImages.forEach((image) => {
          image.classList.add("hide");
        });

        if (currentValue) {
          document.querySelector(`.image-sticky_addtocart-${currentValue}`).classList.remove("hide");
        }
      }

      $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
        setVariantQuantities(cart);
        checkQuantity();
        checkPrice();
        setATCButtonState();
      });

      document.addEventListener("productInfoLoaded", () => {
        setATCButtonState();
      });
    }

    StickyAddtocart();}

  function themeStickyAddtocartDestroy() {document.body.classList.add("dbtfy-sticky_addtocart-destroy");

    destroyStickyAddtocart();

    function destroyStickyAddtocart() {
      const stickyATCs = document.querySelectorAll(".dbtfy-sticky_addtocart");

      stickyATCs.length && stickyATCs.forEach((stickyATC) => {
        stickyATC.remove();
      });
    }}
  /* end-dbtfy-sticky-addtocart */

  /* start-dbtfy-synced-variant-image */
  function themeSyncedVariantImage() {function SyncedVariantImage() {
      const productSections = document.querySelectorAll("[data-section-type='product-template']");

      productSections.length && productSections.forEach((productSection) => {
        const thumbnails = productSection.querySelectorAll(".product-single__thumb");

        if (thumbnails.length > 1) {
          const sectionId = productSection.dataset.sectionId;
          const productJSON = productSection.querySelector("[id^=ProductJson-]");
          const productJSONParsed = productJSON ? JSON.parse(productJSON.innerHTML) : null;

          if (!productJSONParsed) {
            return;
          }

          const variantImages = getVariantImages(productJSONParsed);
          const $slider = $(productSection).find(".product-single__media-group-wrapper .slick");

          if (productJSONParsed.variants.length > 1) {
            let nextSlideIndex = null;

            $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
              nextSlideIndex = nextSlide;
            });

            $slider.on("afterChange", function (event, slick, currentSlide) {
              if (nextSlideIndex !== currentSlide) {
                return;
              }

              nextSlideIndex = 0;

              const thumbnail = thumbnails[currentSlide].closest(".product-single__thumbnail");
              const mediaId = +thumbnail.dataset.mediaId.replace(`${sectionId}-`, "");
              const variantId = variantImages[mediaId] ? variantImages[mediaId].variantId : null;

              if (variantId) {
                updateVariant(productSection, variantId, variantImages, mediaId);
              }
            });
          }
        }
      });

      function getVariantImages(product) {
        const variantImages = {};

        product.variants.forEach((variant) => {
          if (variant.featured_media && variant.featured_media.id) {
            variantImages[variant.featured_media.id] = {
              variantId: variant.id,
              option1: variant.option1,
              option2: variant.option2,
              option3: variant.option3
            };
          }
        });

        return variantImages;
      }

      function updateVariant(productSection, variantId, variantImages, mediaId) {
        const image = variantImages[mediaId];
        const options = [image.option1, image.option2, image.option3];

        options.forEach((option, index) => {
          const optionElements = productSection.querySelectorAll(`.single-option-selector__radio[name='option${index + 1}'][value='${option}'], .single-option-selector__radio[name='option${index + 1}'] option[value='${option}'], .input-color_swatches[data-option-position='option${index + 1}'][value='${option}']`);

          optionElements.forEach((optionElement) => {
            const select = optionElement.closest(".single-option-selector__radio");

            optionElement.checked = true;
            optionElement.value = option;

            if (select) {
              select.value = option;
              select.dispatchEvent(new Event("change"));
            }

            optionElement.dispatchEvent(new Event("change"));
          });
        });
      }
    }

    SyncedVariantImage();}
  /* end-dbtfy-synced-variant-image */

  /* start-dbtfy-trust-badge */
  function themeTrustBadgeDestroy() {destroyTrustBadge();

    function destroyTrustBadge() {
      const trustBadges = document.querySelectorAll(".dbtfy-trust_badge");

      trustBadges.length && trustBadges.forEach((trustBadge) => {
        trustBadge.remove();
      });
    }}
  /* end-dbtfy-trust-badge */

  /* start-dbtfy-upsell-bundles */
  function themeUpsellBundles() {function UpsellBundles() {
      var dbtfy = $(".dbtfy-upsell_bundles");

      if (!dbtfy.length) {
        return;
      }

      var $container = $("#UpsellBundles");
      var position = $container.data("position");
      var sectionId = $container.data("sectionId");
      var productId = $container.data("productId");
      var limit = $container.data("limit");
      var recommendationsSectionUrl = `/recommendations/products?&section_id=${sectionId}&product_id=${productId}&limit=${limit}`;

      // Once bundle is loaded
      function upsellBundleLoaded() {
        var $buttonBundle = $(".btn-upsell_bundles");
        var $bundleSelect = $(".select-upsell_bundles");
        var bundleTotal = $(".total-upsell_bundles");
        let bundleCompareTotal = $(".compare-total-upsell_bundles");
        let discountBox = $(".discount-upsell_bundles");
        let discountBoxText = $(".discount-upsell_bundles_text");
        let discountVariant = $(".total-wrapper-upsell_bundles").data("discount-variant");
        let moneyFormat = theme.strings.moneyFormat;

        // Move current product inside bundle
        $(".current-image-upsell_bundles").prependTo(".image-wrapper-upsell_bundles");
        $(".current-form-upsell_bundles").prependTo(".form-wrapper-upsell_bundles");

        // Position
        if (position === "button") {
          if ($(".dbtfy-trust_badge").length) {
            dbtfy.insertAfter(".dbtfy-trust_badge");
          } else {
            dbtfy.insertAfter("#AddToCartForm--product-template");
          }
        }

        function calculateDiscount(totalPrice, totalComparePrice) {
          let discount = null;

          if (totalComparePrice > totalPrice) {
            if (discountVariant === "percentage") {
              let discountValue = Math.round(((totalComparePrice - totalPrice) * 100) / totalComparePrice);

              discount = `${discountValue}%`;
            } else {
              let discountValue = totalComparePrice - totalPrice;

              discount = `<span class="money">${theme.Currency.formatMoney(discountValue, moneyFormat)}</span>`;
            }

            discountBoxText.html(theme.strings.saveFormat.replace(/\{\{ saved_amount \}\}/, discount));
            bundleTotal.addClass("text-sale");
            discountBox.show();
          } else {
            discountBox.hide();
            bundleTotal.removeClass("text-sale");
          }
        }

        // Price function
        function checkPrice() {
          let totalPrice = 0;
          let totalComparePrice = 0;

          $bundleSelect.each(function() {
            var currentCheckbox = $(this).closest(".form-item-upsell_bundles").find(".checkbox-upsell_bundles");

            if (currentCheckbox.is(":checked")) {
              totalPrice += parseInt($(this).children("option:selected").data("price"));

              let dataComparePrice = parseInt($(this).children("option:selected").data("compare-at-price"));

              if (dataComparePrice > 0) {
                totalComparePrice += dataComparePrice;
              } else {
                totalComparePrice += parseInt($(this).children("option:selected").data("price"));
              }
            }
          });

          bundleTotal.data("total", totalPrice).html(`<span class="money">${theme.Currency.formatMoney(totalPrice, moneyFormat)}</span>`);

          if (totalPrice < totalComparePrice) {
            bundleCompareTotal.data("total", totalComparePrice).html(`<span class="money">${theme.Currency.formatMoney(totalComparePrice, moneyFormat)}</span>`);
            bundleCompareTotal.show();
          } else {
            bundleCompareTotal.hide();
          }

          calculateDiscount(totalPrice, totalComparePrice);

          // Convert the product price on select change based on selected currency
          var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
            shopCurrency = theme.strings.shopCurrency;

          if (currencySelector.length && shopCurrency && Currency.currentCurrency) {
            Currency.convertAll(shopCurrency, Currency.currentCurrency);
          }
        }

        function verifyUnchecked() {
          const upsellBuyButton = document.querySelector(".btn-upsell_bundles");
          const upsellCheckbox = document.querySelectorAll(".checkbox-upsell_bundles");

          const empty = [].filter.call(upsellCheckbox, function (el) {
            return !el.checked;
          });

          if (upsellCheckbox.length === empty.length) {
            upsellBuyButton.classList.add("disabled");
            upsellBuyButton.setAttribute("disabled", "disabled");
          } else {
            upsellBuyButton.classList.remove("disabled");
            upsellBuyButton.removeAttribute("disabled", "disabled");
          }
        }

        // checkbox on click
        $(".checkbox-upsell_bundles").on("click", function() {
          var $this = $(this);
          var productId = $this.data("productId");
          var index = $this.data("index");
          var targetImage = $(`.grid-image-${productId}-${index}`);
          var targetForm = $(`#upsellBundles-${productId}-${index}`);

          if ($this.is(":checked")) {
            targetImage.addClass("selected-image-upsell_bundles");
            targetForm.addClass("active-upsell_bundles");
          } else {
            targetImage.removeClass("selected-image-upsell_bundles");
            targetForm.removeClass("active-upsell_bundles");
          }

          verifyUnchecked();
          checkPrice();
        });

        // Select on change
        $bundleSelect.on("change", function() {
          var selectValue = $(this).val();
          var currentImage = $(`#imageUpsellBundles-${selectValue}`);
          var siblingImages = currentImage.siblings();
          let selectedVariant = $(this).find("option:selected");
          let currentPriceBox = $(this).next(".dbtfy-upsell-bundle-price-wrapper").find(".dbtfy-upsell-bundle-current-price");
          let comparePriceBox = $(this).next(".dbtfy-upsell-bundle-price-wrapper").find(".dbtfy-upsell-bundle-compare-price");
          let variantCurrentPrice = selectedVariant.data("price");
          let variantComparePrice = selectedVariant.data("compare-at-price");

          // Change image
          siblingImages.hide();
          currentImage.show();

          if (variantCurrentPrice > variantComparePrice) {
            currentPriceBox.removeClass("text-sale");
            comparePriceBox.hide();
          } else {
            currentPriceBox.addClass("text-sale");
            comparePriceBox.show();
          }

          currentPriceBox.html(`<span class="money">${theme.Currency.formatMoney(variantCurrentPrice, moneyFormat)}</span>`);
          comparePriceBox.html(`<span class="money">${theme.Currency.formatMoney(variantComparePrice, moneyFormat)}</span>`);

          // Change price
          checkPrice();
        });

        $(document).ready(function() {
          checkPrice();
        });

        // Add bundle to cart
        $buttonBundle.on("click", function() {
          var $btn = $(this);
          let $form = document.querySelectorAll(".form-upsell_bundles.active-upsell_bundles");
          const cartType = theme.settings.cartType;

          theme.loadingState.init($btn);

          dbtfy.find(".errors").remove();

          ShopifyAPI.addItemFromForm(
            $form,
            () => {
              if (cartType === "page") {
                if (document.body.classList.contains("template-cart")) {
                  theme.ajaxCart.update();
                } else {
                  window.location.assign("/cart");
                }
              } else if (cartType === "drawer") {
                theme.ajaxCart.update();

                $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
                  theme.loadingState.destroy($btn);
                });
              }
            },
            (XMLHttpRequest, textStatus, form) => {
              const data = eval(`(${XMLHttpRequest.responseText})`);

              theme.loadingState.destroy($btn);

              if (data.message) {
                if (data.status === 422) {
                  $btn.after(
                    `<div class="errors qty-error">${data.description}</div>`
                  );
                }
              }
            }
          );
        });

      }

      if ($container.hasClass("specific-upsell_bundles")) {
        upsellBundleLoaded();
      } else {
        $.get(recommendationsSectionUrl).then(function(section) {
          var recommendationsMarkup = $(section).find("#UpsellBundles").html();

          if (recommendationsMarkup && recommendationsMarkup.trim() !== "") {
            $container.html(recommendationsMarkup);

            upsellBundleLoaded();
          }
        });
      }

      $(document).on("shopify:section:load", function() {
        upsellBundleLoaded();
      });
    }

    UpsellBundles();}

  function themeUpsellBundlesDestroy() {destroyUpsellBundles();

    function destroyUpsellBundles() {
      const upsellBundles = document.querySelectorAll(".dbtfy-upsell_bundles");

      upsellBundles.length && upsellBundles.forEach((upsellBundle) => {
        upsellBundle.remove();
      });
    }}
  /* end-dbtfy-upsell-bundles */

  /* start-dbtfy-upsell-popup */
  function themeUpsellPopup() {}

  function themeUpsellPopupDestroy() {}
  /* end-dbtfy-upsell-popup */

  /* start-dbtfy-wish-list */
  function themeWishList() {function Wishlist() {
      const dbtfy = document.querySelector(".dbtfy-wish_list");

      if (!dbtfy) {
        return;
      }

      const settings = {
        localStorageName: "wishlist",
        activeClass: "wl-active",
        hiddenClass: "hidden",
        submitButtonDefaultClass: "btn-outline-primary",
        submitButtonAddedClass: "btn--primary",
        addButtons: ".wl-add",
        removeButtons: ".wl-remove",
        submitButtons: ".wl-button",
        atcSelects: ".wl-select",
        wlItems: ".wl-item",
        wlCounts: ".wl-count",
        wishlistSocial: document.querySelector(".wl-social-sharing"),
        noItems: document.querySelectorAll(".wl-no-item"),
        bubbleIcons: document.querySelectorAll(".wl-bubble"),
        pageTemplate: document.getElementById("WishlistTemplate")
      };

      init();

      function init() {
        const sections = new theme.Sections();

        sections.register("wish-list-page", initWishListPage);

        initWishlist();

        $("body").on("afterRecommendationLoad", function(evt) {
          initWishlist();
        });
      }

      function initWishlist() {
        initWishlistHeaderBubble();
        initWishlistAddEvent();
        initWishlistRemoveEvent();
      }

      function initWishlistHeaderBubble() {
        const storedWishlist = getStoredWishlist();

        if (!storedWishlist || !storedWishlist.length) {
          // Update wishlist count
          setWishlistCount(0);

          return;
        }

        const filteredWishlist = storedWishlist.filter((handle) => {
          return !!handle;
        });

        filteredWishlist.forEach((productHandle) => {
          const wishlistIconsWithCurrentProduct = document.querySelectorAll(`${settings.addButtons}[data-product-handle="${productHandle}"]`);

          wishlistIconsWithCurrentProduct && wishlistIconsWithCurrentProduct.forEach((wishlistIcon) => {
            let removeWishlistText = wishlistIcon.getAttribute("data-remove-wish-list-text");

            wishlistIcon.classList.add(settings.activeClass);
            wishlistIcon.setAttribute("aria-label", removeWishlistText);
            wishlistIcon.setAttribute("title", removeWishlistText);
          });
        });

        setElementsVisibility(settings.bubbleIcons, true);

        // Update wishlist count
        theme.fetchProductMarkup({
          template: "wish-list",
          productHandles: filteredWishlist
        }, (productMarkups) => {
          const availableProductsCount = Object.entries(productMarkups).reduce((acc, [productHandle, markup]) => {
            if (markup.includes("<!doctype html>")) {
              return acc;
            }

            return acc + 1;
          }, 0);

          setWishlistCount(availableProductsCount);
        });
      }

      function initWishlistAddEvent() {
        const addButtons = document.querySelectorAll(settings.addButtons);

        addButtons && addButtons.length && addButtons.forEach((addButton) => {
          const hasClickEvent = addButton.hasAttribute("data-has-click-event");

          if (!hasClickEvent) {
            addButton.addEventListener("click", () => {
              const productHandle = addButton.dataset.productHandle;
              const isActiveButton = addButton.classList.contains(settings.activeClass);
              const isAddAction = !isActiveButton;
              const addWishlistText = addButton.getAttribute("data-add-wish-list-text");
              const removeWishlistText = addButton.getAttribute("data-remove-wish-list-text");

              if (!productHandle) {
                return;
              }


              if (isActiveButton) {
                addButton.classList.remove(settings.activeClass);
                addButton.setAttribute("aria-label", addWishlistText);
                addButton.setAttribute("title", addWishlistText);
              } else {
                addButton.classList.add(settings.activeClass);
                addButton.setAttribute("aria-label", removeWishlistText);
                addButton.setAttribute("title", removeWishlistText);
              }

              updateWishlist(isAddAction, productHandle);
            });

            addButton.setAttribute("data-has-click-event", "true");
          }
        });
      }

      function initWishlistRemoveEvent() {
        const removeButtons = document.querySelectorAll(settings.removeButtons);

        removeButtons && removeButtons.length && removeButtons.forEach((removeButton) => {
          const hasClickEvent = removeButton.hasAttribute("data-has-click-event");

          if (!hasClickEvent) {
            removeButton.addEventListener("click", (e) => {
              e.preventDefault();

              const productHandle = removeButton.dataset.productHandle;

              if (!productHandle || removeButton.hasAttribute("data-has-remove-event")) {
                return;
              }

              updateWishlist(false, productHandle);
            });

            removeButton.setAttribute("data-has-click-event", "true");
          }
        });
      }

      function initWishListPage() {
        let storedWishlist = getStoredWishlist();

        // If URL contains wishlist products list
        if (window.location.href.indexOf("?wishlist") > -1) {
          const wishlistUrlParams = window.location.href.split('?');
          const wishlistQueryParams = new URLSearchParams(wishlistUrlParams[1]);
          const wishlistProducts = wishlistQueryParams.get("wishlist").split(",");

          wishlistProducts.forEach(function (productHandle) {
            if (!storedWishlist || !storedWishlist.length) {
              storedWishlist = [productHandle];
            } else {
              storedWishlist = storedWishlist.filter((storedProductHandle) => {
                return storedProductHandle !== productHandle;
              });

              storedWishlist.push(productHandle);
            }
          });

          storedWishlist = JSON.stringify(storedWishlist);

          saveWishlistToLocalStorage(storedWishlist);
          initWishlistHeaderBubble();

          storedWishlist = getStoredWishlist();
        }

        if (!storedWishlist || !storedWishlist.length) {
          setElementsVisibility(settings.noItems, true);
          setElementsVisibility([settings.wishlistSocial], false);

          return;
        }

        const filteredWishlist = storedWishlist.filter((productHandle) => {
          return !!productHandle;
        });

        setElementsVisibility(settings.noItems, false);
        setElementsVisibility([settings.wishlistSocial], true);

        theme.fetchProductMarkup({
          template: "wish-list",
          productHandles: filteredWishlist
        }, (productMarkups) => {
          let visibleProductsCount = 0;
          const wishlistMarkup = Object.entries(productMarkups).reduce((acc, [productHandle, markup]) => {
            if (markup.includes("<!doctype html>")) {
              return acc;
            }

            visibleProductsCount++;

            return acc + `<div id="WishlistCard-${productHandle}" class="card fadeInUp"><div class="card-body">${markup}</div></div>`;
          }, "");

          setWishlistCount(visibleProductsCount);

          if (!wishlistMarkup) {
            setElementsVisibility(settings.noItems, true);
            setElementsVisibility([settings.wishlistSocial], false);
            setWishlistCount(0);
          } else {
            settings.pageTemplate.insertAdjacentHTML("afterbegin", wishlistMarkup);

            initWishlistAddEvent();
            initWishlistRemoveEvent();
            initWishlistPageAddtocart();
            initAjaxDrawer();
            themeUpsellPopup();
          }
        });

        // Share wishlist products
        const socialSharingUrl = `${window.location.href}%3Fwishlist=${filteredWishlist}`;
        const facebookIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector(".btn-facebook") : null;
        const twitterIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-twitter') : null;
        const pinterestIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-pinterest') : null;
        const whatsappIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-whatsapp') : null;
        const linkedinIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-linkedin') : null;
        const redditIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-reddit') : null;
        const emailIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-email') : null;
        const messengerIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-messenger') : null;

        if (facebookIcon) {
          let shareContent = facebookIcon.dataset.shareContent;

          facebookIcon.setAttribute('href', `//www.facebook.com/sharer/sharer.php?u=${socialSharingUrl}&quote=${shareContent}`);
        }

        if (twitterIcon) {
          let shareContent = twitterIcon.dataset.shareContent;

          twitterIcon.setAttribute('href', `//twitter.com/intent/tweet?source=${socialSharingUrl}&text=${socialSharingUrl}%20${shareContent}`);
        }

        if (pinterestIcon) {
          let shareContent = pinterestIcon.dataset.shareContent;
          let shareMedia = encodeURIComponent(pinterestIcon.dataset.shareMedia);

          pinterestIcon.setAttribute('href', `//pinterest.com/pin/create/button/?url=${socialSharingUrl}&media=${shareMedia}&description=${shareContent}`);
        }

        if (whatsappIcon) {
          whatsappIcon.setAttribute('href', `//api.whatsapp.com/send?text=${socialSharingUrl}`);
        }

        if (linkedinIcon) {
          let shareTitle = linkedinIcon.dataset.shareTitle;
          let shareDescription = linkedinIcon.dataset.shareDescription;

          linkedinIcon.setAttribute('href', `//www.linkedin.com/shareArticle?mini=true&url=${socialSharingUrl}&title=${shareTitle}&summary=${shareDescription}&source=${socialSharingUrl}`);
        }

        if (redditIcon) {
          let shareContent = redditIcon.dataset.shareContent;

          redditIcon.setAttribute('href', `//www.reddit.com/submit?url=${socialSharingUrl}&title=${shareContent}`);
        }

        if (emailIcon) {
          let shareContent = emailIcon.dataset.shareContent;
          let shareTitle = emailIcon.dataset.shareTitle;

          emailIcon.setAttribute('href', `mailto:?subject=${shareTitle}&body=${socialSharingUrl}%0D%0D${shareContent}%0D`);
        }

        if (messengerIcon) {
          messengerIcon.setAttribute('href', `fb-messenger://share/?link=${socialSharingUrl}&app_id=`);
        }
        // End share wishlist products
      }

      function initWishlistPageAddtocart() {
        const submitButtons = document.querySelectorAll(settings.submitButtons);
        const atcSelects = document.querySelectorAll(settings.atcSelects);

        submitButtons && submitButtons.length && submitButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            theme.loadingState.init(button);

            $("body").on("ajaxCart.afterCartLoad", (evt, cart) => {
              theme.loadingState.destroy(button);
            });
          });
        });

        atcSelects.length && atcSelects.forEach((select) => {
          select.addEventListener("change", (e) => {
            const $body = $("body");
            const submitButton = select.nextElementSibling;

            if (submitButton) {
              setElementsVisibility([select], false);
              setElementsVisibility([submitButton], true);

              submitButton.click();

              window.wishlistAdded = true;

              $body.on("ajaxCart.afterCartLoad", (evt, cart) => {
                if (theme.settings.cartType === "drawer") {
                  timber.RightDrawer.init();
                  timber.RightDrawer.open();
                }

                setElementsVisibility([select], true);
                setElementsVisibility([submitButton], false);

                const isProductInCart = cart.items.some((item) => {
                  return item.id === +select.value;
                });

                if (isProductInCart) {
                  submitButton.classList.remove(settings.submitButtonDefaultClass);
                  submitButton.classList.add(settings.submitButtonAddedClass);

                  select.classList.remove(settings.submitButtonDefaultClass);
                  select.classList.add(settings.submitButtonAddedClass);
                } else {
                  submitButton.classList.add(settings.submitButtonDefaultClass);
                  submitButton.classList.remove(settings.submitButtonAddedClass);

                  select.classList.add(settings.submitButtonDefaultClass);
                  select.classList.remove(settings.submitButtonAddedClass);
                  select.selectedIndex = 0;
                }
              });

              $body.on("ajaxCart.cartAddError", (evt, cart) => {
                setElementsVisibility([select], true);
                setElementsVisibility([submitButton], false);
              });
            }
          });

          /* Convert options select dropdown price */
          var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']");

          if (currencySelector.length) {
            Array.from(select.options).forEach((option) => {
              let variantTitle = option.getAttribute("data-variant-title"),
                variantPrice = parseFloat(option.getAttribute("data-variant-price")),
                shopCurrency = theme.strings.shopCurrency;

              if (!isNaN(variantPrice)) {
                var newVariantPrice = Currency.convert(variantPrice, shopCurrency, Currency.currentCurrency),
                  formattedPrice = Currency.formatMoney(newVariantPrice, Currency.moneyFormats[Currency.currentCurrency].money_format);

                option.innerHTML = (`${variantTitle} - ${formattedPrice}`);
              }
            });
          }
        });
      }

      function initAjaxDrawer() {
        if (theme.settings.cartType === "drawer") {
          theme.ajaxCart.init();
        }
      }

      function updateWishlist(isAddAction, productHandle) {
        const wishlistItem = document.getElementById(`WishlistCard-${productHandle}`);

        let wishlist = getStoredWishlist();

        if (isAddAction) {
          if (!wishlist) {
            wishlist = [productHandle];
          } else {
            wishlist.push(productHandle);
          }
        } else {
          wishlistItem && wishlistItem.remove();

          // Get new wishlist without target product
          wishlist = wishlist.filter((storedProductHandle) => {
            return storedProductHandle !== productHandle;
          });
        }

        if (wishlist && wishlist.length) {
          setElementsVisibility(settings.bubbleIcons, true);
          setElementsVisibility(settings.noItems, false);
          setElementsVisibility([settings.wishlistSocial], true);
        } else {
          setElementsVisibility(settings.bubbleIcons, false);
          setElementsVisibility(settings.noItems, true);
          setElementsVisibility([settings.wishlistSocial], false);
        }

        wishlist = JSON.stringify(wishlist);

        saveWishlistToLocalStorage(wishlist);
        initWishlistHeaderBubble();
      }

      function setElementsVisibility(elements, isToShow) {
        elements.length && elements.forEach((elem) => {
          if (elem) {
            elem.style.display = isToShow ? "block" : "none";
          }
        });
      }

      function setWishlistCount(count) {
        const wlCounts = document.querySelectorAll(settings.wlCounts);

        wlCounts.length && wlCounts.forEach((wlCount) => {
          wlCount.innerHTML = count;
        });
      }

      function getStoredWishlist() {
        const storedWishlist = localStorage.getItem(settings.localStorageName);

        return JSON.parse(storedWishlist);
      }

      function saveWishlistToLocalStorage(wishlist) {
        localStorage.setItem(settings.localStorageName, wishlist);
      }
    }

    Wishlist();}

  function themeWishListDestroy() {document.body.classList.add("dbtfy-wish_list-destroy");

    destroyWishlist();

    $("body").on("afterRecommendationLoad", function (evt) {
      destroyWishlist();
    });

    $("body").on("ajaxCart.afterCartLoad", function (evt) {
      destroyWishlist();
    });

    function destroyWishlist() {
      const wishlistIcons = document.querySelectorAll(".dbtfy-wish_list");

      wishlistIcons.length && wishlistIcons.forEach((wishlistIcon) => {
        wishlistIcon.remove();
      });
    }}
  /* end-dbtfy-wish-list */

  document.addEventListener("dbtfy:loaded", function(event) {
    /* start-register */
    var sections = new theme.Sections();

    const addons = {
      "dbtfy_addtocart_animation": {
        "init": () => {
          sections.register("product-template", themeAddtocartAnimation);
        },
        "destroy": () => {}
      },
      "dbtfy_age_check": {
        "init": themeAgeCheck,
        "destroy": themeAgeCheckDestroy
      },
      "dbtfy_agree_to_terms": {
        "init": themeAgreeToTerms,
        "destroy": themeAgreeToTermsDestroy
      },
      "dbtfy_automatic_geolocation": {
        "init": themeAutomaticGeolocation,
        "destroy": () => {}
      },
      "dbtfy_back_in_stock": {
        "init": themeBackInStock,
        "destroy": themeBackInStockDestroy
      },
      "dbtfy_cart_countdown": {
        "init": themeCartCountdown,
        "destroy": themeCartCountdownDestroy
      },
      "dbtfy_cart_discount": {
        "init": themeCartDiscount,
        "destroy": themeCartDiscountDestroy
      },
      "dbtfy_cart_favicon": {
        "init": themeCartFavicon,
        "destroy": () => {}
      },
      "dbtfy_cart_goal": {
        "init": themeCartGoal,
        "destroy": themeCartGoalDestroy
      },
      "dbtfy_cart_savings": {
        "init": themeCartSavings,
        "destroy": themeCartSavingsDestroy
      },
      "dbtfy_cart_upsell": {
        "init": themeCartUpsell,
        "destroy": themeCartUpsellDestroy
      },
      "dbtfy_collection_addtocart": {
        "init": themeCollectionAddtocart,
        "destroy": themeCollectionAddtocartDestroy
      },
      "dbtfy_collection_filters": {
        "init": themeCollectionFilters,
        "destroy": themeCollectionFiltersDestroy
      },
      "dbtfy_color_swatches": {
        "init": themeColorSwatches,
        "destroy": themeColorSwatchesDestroy
      },
      "dbtfy_cookie_box": {
        "init": themeCookieBox,
        "destroy": themeCookieBoxDestroy
      },
      "dbtfy_custom_currencies": {
        "init": themeCustomCurrencies,
        "destroy": themeCustomCurrenciesDestroy
      },
      "dbtfy_delivery_time": {
        "init": () => {},
        "destroy": themeDeliveryTimeDestroy
      },
      "dbtfy_discount_saved": {
        "init": themeDiscountSaved,
        "destroy": themeDiscountSavedDestroy
      },
      "dbtfy_faq_page": {
        "init": () => {
          sections.register("faq-page", themeFaqPage);
        },
        "destroy": themeFaqPageDestroy
      },
      "dbtfy_facebook_messenger": {
        "init": () => {},
        "destroy": themeFacebookMessengerDestroy
      },
      "dbtfy_inactive_tab_message": {
        "init": themeInactiveTabMessage,
        "destroy": () => {}
      },
      "dbtfy_infinite_scroll": {
        "init": themeInfiniteScroll,
        "destroy": themeInfiniteScrollDestroy
      },
      "dbtfy_instagram_feed": {
        "init": () => {
          sections.register("instagram-feed", themeInstagramFeed);
        },
        "destroy": themeInstagramFeedDestroy
      },
      "dbtfy_inventory_quantity": {
        "init": themeInventoryQuantity,
        "destroy": themeInventoryQuantityDestroy
      },
      "dbtfy_linked_options": {
        "init": themeLinkedOptions,
        "destroy": () => {}
      },
      "dbtfy_live_view": {
        "init": () => {
          sections.register("product-template", themeLiveView);
        },
        "destroy": themeLiveViewDestroy
      },
      "dbtfy_mega_menu": {
        "init": () => {
          sections.register("header-section", themeMegaMenu);
        },
        "destroy": themeMegaMenuDestroy
      },
      "dbtfy_menu_bar": {
        "init": () => {},
        "destroy": themeMenuBarDestroy
      },
      "dbtfy_newsletter_popup": {
        "init": themeNewsletterPopup,
        "destroy": themeNewsletterPopupDestroy
      },
      "dbtfy_order_feedback": {
        "init": themeOrderFeedback,
        "destroy": themeOrderFeedbackDestroy
      },
      "dbtfy_order_tracking": {
        "init": themeOrderTracking,
        "destroy": themeOrderTrackingDestroy
      },
      "dbtfy_page_speed_booster": {
        "init": themePageSpeedBooster,
        "destroy": () => {}
      },
      "dbtfy_page_transition": {
        "init": themePageTransition,
        "destroy": themePageTransitionDestroy
      },
      "dbtfy_pricing_table": {
        "init": () => {},
        "destroy": themePricingTableDestroy
      },
      "dbtfy_product_bullet_points": {
        "init": themeProductBulletPoints,
        "destroy": themeProductBulletPointsDestroy
      },
      "dbtfy_product_image_crop": {
        "init": () => {},
        "destroy": themeProductImageCropDestroy
      },
      "dbtfy_product_tabs": {
        "init": () => {},
        "destroy": themeProductTabsDestroy
      },
      "dbtfy_quantity_breaks": {
        "init": themeQuantityBreaks,
        "destroy": themeQuantityBreaksDestroy
      },
      "dbtfy_quick_view": {
        "init": themeQuickView,
        "destroy": themeQuickViewDestroy
      },
      "dbtfy_recently_viewed": {
        "init": themeRecentlyViewed,
        "destroy": themeRecentlyViewedDestroy
      },
      "dbtfy_sales_countdown": {
        "init": themeSalesCountdown,
        "destroy": themeSalesCountdownDestroy
      },
      "dbtfy_sales_pop": {
        "init": themeSalesPop,
        "destroy": themeSalesPopDestroy
      },
      "dbtfy_shop_protect": {
        "init": themeShopProtect,
        "destroy": () => {}
      },
      "dbtfy_size_chart": {
        "init": () => {
          sections.register("product-template", themeSizeChart);
        },
        "destroy": themeSizeChartDestroy
      },
      "dbtfy_smart_search": {
        "init": themeSmartSearch,
        "destroy": themeSmartSearchDestroy
      },
      "dbtfy_social_discount": {
        "init": () => {
          sections.register("product-template", themeSocialDiscount);
        },
        "destroy": themeSocialDiscountDestroy
      },
      "dbtfy_sticky_addtocart": {
        "init": () => {
          sections.register("product-template", themeStickyAddtocart);
        },
        "destroy": themeStickyAddtocartDestroy
      },
      "dbtfy_synced_variant_image": {
        "init": themeSyncedVariantImage,
        "destroy": () => {}
      },
      "dbtfy_trust_badge": {
        "init": () => {},
        "destroy": themeTrustBadgeDestroy
      },
      "dbtfy_upsell_bundles": {
        "init": () => {
          sections.register("bundle-recommendations", themeUpsellBundles);
        },
        "destroy": themeUpsellBundlesDestroy
      },
      "dbtfy_upsell_popup": {
        "init": () => {
          sections.register("upsell-popup", themeUpsellPopup);
        },
        "destroy": themeUpsellPopupDestroy
      },
      "dbtfy_wish_list": {
        "init": themeWishList,
        "destroy": themeWishListDestroy
      }
    };

    const enabledAddons = event.detail.enabledAddons;

    for (const [addonName, addonInfo] of Object.entries(addons)) {
      const isEnabledAddon = enabledAddons.some((enabledAddon) => {
        return enabledAddon.name === addonName;
      });

      if (isEnabledAddon) {
        addonInfo.init();
      } else {
        addonInfo.destroy();
      }
    }
    /* end-register */
  });
})();
